webpackJsonp([6],{

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AlKc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BEit":
/***/ (function(module, exports) {

module.exports = [{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ECDSAInvalidSignature","type":"error"},{"inputs":[{"internalType":"uint256","name":"length","type":"uint256"}],"name":"ECDSAInvalidSignatureLength","type":"error"},{"inputs":[{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"ECDSAInvalidSignatureS","type":"error"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"allowance","type":"uint256"},{"internalType":"uint256","name":"needed","type":"uint256"}],"name":"ERC20InsufficientAllowance","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"uint256","name":"balance","type":"uint256"},{"internalType":"uint256","name":"needed","type":"uint256"}],"name":"ERC20InsufficientBalance","type":"error"},{"inputs":[{"internalType":"address","name":"approver","type":"address"}],"name":"ERC20InvalidApprover","type":"error"},{"inputs":[{"internalType":"address","name":"receiver","type":"address"}],"name":"ERC20InvalidReceiver","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"}],"name":"ERC20InvalidSender","type":"error"},{"inputs":[{"internalType":"address","name":"spender","type":"address"}],"name":"ERC20InvalidSpender","type":"error"},{"inputs":[{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"ERC2612ExpiredSignature","type":"error"},{"inputs":[{"internalType":"address","name":"signer","type":"address"},{"internalType":"address","name":"owner","type":"address"}],"name":"ERC2612InvalidSigner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"uint256","name":"currentNonce","type":"uint256"}],"name":"InvalidAccountNonce","type":"error"},{"inputs":[],"name":"InvalidShortString","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},{"inputs":[{"internalType":"string","name":"str","type":"string"}],"name":"StringTooLong","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[],"name":"EIP712DomainChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"account","type":"address"},{"indexed":false,"internalType":"bool","name":"isExcluded","type":"bool"}],"name":"ExcludeFromLimits","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_maxTxAmount","type":"uint256"}],"name":"MaxTxAmountUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"string","name":"paint","type":"string"}],"name":"Paint","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"totalWallets","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totaBitTokens","type":"uint256"}],"name":"TokensAirdropped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[],"name":"DOMAIN_SEPARATOR","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_buyCount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxTaxSwap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxTxAmount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_maxWalletSize","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"_taxSwapThreshold","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"addLiquidity","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address[]","name":"addresses","type":"address[]"},{"internalType":"uint256[]","name":"tokenAmounts","type":"uint256[]"}],"name":"airdrop","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"accounts","type":"address[]"},{"internalType":"bool","name":"value","type":"bool"}],"name":"bulkExcludeFromMaxTransaction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"deadAddress","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"eip712Domain","outputs":[{"internalType":"bytes1","name":"fields","type":"bytes1"},{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"version","type":"string"},{"internalType":"uint256","name":"chainId","type":"uint256"},{"internalType":"address","name":"verifyingContract","type":"address"},{"internalType":"bytes32","name":"salt","type":"bytes32"},{"internalType":"uint256[]","name":"extensions","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"enableTrading","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"excludeFromMaxTransaction","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isExcludedFromMaxTransaction","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"isPair","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"manualSwap","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"nonces","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"paintData","type":"string"}],"name":"paint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"permit","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_newFee","type":"uint256"}],"name":"reduceFee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"removeLimits","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"setFinalMaxWallet","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"setFinalTax","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"},{"internalType":"bool","name":"value","type":"bool"}],"name":"setPair","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tradingActive","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapV2Pair","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"uniswapV2Router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tkn","type":"address"}],"name":"withdrawStuckTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}]

/***/ }),

/***/ "KlKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__("L/hj");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/*global axios*/

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'homepage',
  data: function data() {
    return {
      links: [],
      transactions: [],
      // links: [{c: '0,0,1,1', u: 'http://google.com'}],
      s3Base: BASE_S3_BUCKET,
      s3BaseTrx: BASE_S3_BUCKET_TRX,
      // Lossless WebP of the billboard (about half the JPEG); falls back to the JPEG.
      s3ImgSrc: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getTsPath('homepage.webp'),
      s3VidSrc: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getTsPath('homepage.mp4'), // BASE_S3_BUCKET+'homepage.jpeg?'+Date.now(),
      s3LinkMap: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getTsPath('link_map.json'), // BASE_S3_BUCKET+'link_map.json?'+Date.now(),
      s3TransactionsJson: __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getTsPath('transactions.json'), // BASE_S3_BUCKET+'transactions.json?'+Date.now(),
      isBillboardLoaded: false,
      hovering: false, // To track whether the mouse is hovering over the image
      mouseX: 0, // To store the X coordinate of the mouse
      mouseY: 0, // To store the Y coordinate of the mouse
      tooltipTxt: '',
      showVideo: false,
      inspectMode: false,
      inspectTrx: null
    };
  },

  inject: ['updateAppRoute', 'saveEvent', 'doUpload', 'appData'],
  methods: {
    playVideo: function playVideo() {
      this.showVideo = !this.showVideo;
    },
    toggleInspect: function toggleInspect() {
      this.inspectMode = !this.inspectMode;
      if (!this.inspectMode) {
        this.inspectTrx = null;
      }
    },
    onBillboardError: function onBillboardError() {
      // No WebP yet (CloudFront answers a missing key with index.html): use the JPEG.
      if (this.s3ImgSrc.indexOf('homepage.webp') !== -1) {
        this.s3ImgSrc = this.s3ImgSrc.replace('homepage.webp', 'homepage.jpeg');
      }
    },
    onBillboardLoaded: function onBillboardLoaded() {
      if (!this.isBillboardLoaded) {
        // Only trigger once (since we may reload the image later)
        this.isBillboardLoaded = true;
        this.updateAppRoute('/');
      }
    },
    clickBillboard: function clickBillboard(e) {
      // console.log('clickBillboard', e, e.target, typeof e.target, e.target.coords);
      // Don't track dragging image
      if (this.showVideo) return;
      if (this.appData().canBuy) {
        return;
      }
      // const { offsetX, offsetY } = e;

      // Get the mouse coordinates relative to the image even on mobile where iphone is scrolled down the page
      var target = e.currentTarget || e.target;
      var rect = target.getBoundingClientRect();
      var clientX = e.clientX;
      var clientY = e.clientY;

      var offsetX = clientX - rect.left;
      var offsetY = clientY - rect.top;

      if (!this.inspectMode) {
        if (e.target && e.target.coords) {
          var link = this.getLinkFromCoords(offsetX, offsetY);
          if (link) {
            this.saveEvent('clickBillboard', {
              url: link.u,
              x: offsetX,
              y: offsetY
            });
            __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard', { url: link.u });
            __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard:' + link.u);
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('clickBillboard:emptySpace');
          if (!this.appData().isMobileOrTouch) {
            // Don't do this on mobile
            this.doUpload(offsetX, offsetY);
          }
        }
      } else {
        e.preventDefault();
        var trx = this.getTrxFromCoords(offsetX, offsetY);
        if (trx) {
          this.inspectTrx = trx;

          // Scroll to plot-inspect
          var plotInspect = document.getElementById('plot-inspect');
          if (plotInspect) {
            plotInspect.scrollIntoView({ behavior: 'smooth' });
          }
          this.saveEvent('clickBillboardInspect', {
            tokenId: trx.tokenId,
            x: offsetX,
            y: offsetY
          });
        }
      }
    },
    onMouseEnter: function onMouseEnter() {
      if (this.showVideo) return;
      this.hovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.hovering = false;
    },
    onMouseMove: function onMouseMove(e) {
      if (this.showVideo) return;
      if (this.appData().isMobileOrTouch) {
        return;
      }
      if (this.appData().canBuy) {
        this.hovering = false;
        return;
      }
      // Get the mouse coordinates relative to the image
      var rect = e.target.getBoundingClientRect();
      this.mouseX = e.clientX - rect.left;
      this.mouseY = e.clientY - rect.top;
      // console.log(`Mouse move: ${this.mouseX}, ${this.mouseY}`, e.target.coords);
      if (!this.inspectMode) {
        if (e.target && e.target.coords) {
          var offsetX = e.offsetX,
              offsetY = e.offsetY;

          var link = this.getLinkFromCoords(offsetX, offsetY);
          if (link && link.u) {
            var _link$c$split = link.c.split(','),
                _link$c$split2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split, 4),
                x1 = _link$c$split2[0],
                y1 = _link$c$split2[1],
                x2 = _link$c$split2[2],
                y2 = _link$c$split2[3];
            // console.log(`Mouse over link: ${link.u}`, link, x1, y1, x2, y2);


            this.$refs.tooltip.textContent = link.u;
          }
        } else {
          // console.log('Mouse over blank space');
          this.$refs.tooltip.textContent = 'Claim this space';
        }
        this.$refs.tooltip.style.left = this.mouseX + 'px';
        this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
        this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
      } else {
        if (e.target && e.target.coords) {
          var _offsetX = e.offsetX,
              _offsetY = e.offsetY;

          var trx = this.getTrxFromCoords(_offsetX, _offsetY);
          if (trx) {
            this.$refs.tooltip.textContent = 'Plot ' + trx.tokenId;
          } else {
            this.$refs.tooltip.textContent = 'Claim this space';
          }
        }
        this.$refs.tooltip.style.left = this.mouseX + 'px';
        this.$refs.tooltip.style.top = this.mouseY - 50 + 'px';
        this.$refs.tooltip.style.marginLeft = '-' + this.$refs.tooltip.offsetWidth / 2 + 'px';
      }
    },

    getTrxFromCoords: function getTrxFromCoords(x, y) {
      for (var i = 0; i < this.transactions.length; i++) {
        var t = this.transactions[i];
        if (t.x1 <= x && t.x2 >= x && t.y1 <= y && t.y2 >= y) {
          return t;
        }
      }
    },
    getLinkFromCoords: function getLinkFromCoords(x, y) {
      var links = this.links;
      for (var i = 0; i < links.length; i++) {
        var link = links[i];

        var _link$c$split3 = link.c.split(','),
            _link$c$split4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_link$c$split3, 4),
            x1 = _link$c$split4[0],
            y1 = _link$c$split4[1],
            x2 = _link$c$split4[2],
            y2 = _link$c$split4[3];

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
          return link;
        }
      }
      return null;
    },
    toastTransaction: function toastTransaction(t) {
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].toast({
        title: t.pixels + ' pixels sold!',
        message: 'To ' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].escapeHtml(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].truncateString(t.from)) + '<br />' + __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].escapeHtml(t.url),
        img: this.s3BaseTrx + t.hash + '-crop.jpeg',
        type: "success",
        duration: 10000
      });
      __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].trackEvent('toastTransaction');
    },
    toastTransactions: function toastTransactions() {
      var _this = this;

      try {
        var recentTransactions = this.transactions.slice(0, 5);
        if (!window.toastInterval) {
          window.toastInterval = setInterval(function () {
            if (recentTransactions.length > 0) {
              var t = recentTransactions.shift();
              var trxKey = 'toastedTrx-' + t.hash;
              if (localStorage.getItem(trxKey)) {
                return;
              }
              localStorage.setItem(trxKey, true);
              _this.toastTransaction(t);
            }
          }, 30000);
        }
      } catch (e) {
        console.error('toastTransactions', e);
      }
    },
    fetchData: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(doReload) {
        var self;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = this;

                if (doReload) {
                  this.s3ImgSrc = __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* default */].getFreshPath('homepage.webp');
                }
                return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                  axios.get(self.s3LinkMap).then(function (response) {
                    window.linkMap = self.links = response.data;
                    axios.get(self.s3TransactionsJson).then(function (response) {
                      self.transactions = response.data;
                      self.toastTransactions();
                      resolve();
                    });
                  }).catch(function (error) {
                    console.log('Error loading ' + self.s3LinkMap, error);
                    reject(error);
                  });
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchData;
    }()
  },
  created: function created() {
    this.fetchData();
  },
  mounted: function mounted() {
    var _this2 = this;

    // Do popup on first visit
    var DID_SEE_WELCOME_SCREEN_KEY = 'DID_SEE_WELCOME_SCREEN';
    if (!localStorage.getItem(DID_SEE_WELCOME_SCREEN_KEY)) {
      setTimeout(function () {
        localStorage.setItem(DID_SEE_WELCOME_SCREEN_KEY, true);
        _this2.$bvModal.show('modal-intro');
      }, 5000);
    }
  }
});

/***/ }),

/***/ "L/hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

// import Vue from 'vue'

// Plot URLs and profiles are user-supplied on-chain data: never render them as
// HTML, and only link to http(s).
function escapeHtml(str) {
  return String(str === undefined || str === null ? '' : str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function safeUrl(url) {
  return typeof url === 'string' && /^https?:\/\//i.test(url.trim()) ? url : undefined;
}

// Toast function. `message` is HTML: escape untrusted parts before passing them.
function toast(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === undefined ? "" : _ref$title,
      _ref$message = _ref.message,
      message = _ref$message === undefined ? "" : _ref$message,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "info" : _ref$type,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 3000 : _ref$duration,
      _ref$img = _ref.img,
      img = _ref$img === undefined ? "" : _ref$img;

  var main = document.getElementById("toast");
  if (main) {
    var _toast = document.createElement("div");

    // Auto remove toast
    var autoRemoveId = setTimeout(function () {
      main.removeChild(_toast);
    }, duration + 1000);

    // Remove toast when clicked
    _toast.onclick = function (e) {
      // if (e.target.closest(".toast_close")) {
      main.removeChild(_toast);
      clearTimeout(autoRemoveId);
      // }
    };

    var delay = (duration / 1000).toFixed(2);

    _toast.classList.add("toaster", 'toast-' + type);
    _toast.style.animation = 'slideInLeft ease .3s, fadeOut linear 1s ' + delay + 's forwards';

    _toast.innerHTML = '\n                    <div class="toast_icon">\n                        <img src="' + escapeHtml(img) + '" />\n                    </div>\n                    <div class="toast_body">\n                        <h3 class="toast_title">' + escapeHtml(title) + '</h3>\n                        <p class="toast_msg">' + message + '</p>\n                    </div>\n                ';
    main.appendChild(_toast);
  }
}

function isMobileOrTouch() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

var convertChainIdToCoinType = function convertChainIdToCoinType(chainId) {
  // L1 resolvers to addr
  if (chainId === 1) {
    // 1 is mainnet chain id
    return 'addr';
  }
  var cointype = (0x80000000 | chainId) >>> 0;
  return cointype.toString(16).toLocaleUpperCase();
};
var convertReverseNodeToBytes = function convertReverseNodeToBytes(address, chainId) {
  var addressFormatted = address.toLowerCase();
  var addressNode = ethers.solidityPackedKeccak256(['string'], [addressFormatted.substring(2)]); // NOTE: hash it as a string not address
  var chainCoinType = convertChainIdToCoinType(chainId);
  var baseReverseNode = ethers.namehash(chainCoinType.toLocaleUpperCase() + '.reverse');
  var addressReverseNode = ethers.solidityPackedKeccak256(['bytes32', 'bytes32'], [baseReverseNode, addressNode]);
  return addressReverseNode;
};

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  var pixels_arr = [];
  var p = 0;
  for (var i in myImageData) {
    if (i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if (i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if (i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if (i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }

  var rows = [];
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for (var hi = 0; hi < ha.length; hi++) {
    // for each vertical section
    var cols = [];
    for (var wi = 0; wi < wa.length; wi++) {
      // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }

  // rows is multidimension array to hold image data

  var _loop = function _loop(row) {
    // for each vertical section
    _.times(16, function (y) {
      var _loop2 = function _loop2(col) {
        // for each horizontal section
        _.times(16, function (x) {
          rows[row][col].push(pixels_arr.shift());
        });
      };

      for (var col = 0; col < wa.length; col++) {
        _loop2(col);
      }
    });
  };

  for (var row = 0; row < ha.length; row++) {
    _loop(row);
  }

  return rows;
}

function stringDataForEth(arr, url, bid, r, c, img_offset_x, img_offset_y) {
  var DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)

  if (typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if (typeof c === 'string') {
    c = parseInt(c, 10);
  }

  var colors = [];
  for (var i in arr) {
    var p = arr[i];
    colors.push(p['hex']);
  }
  var xOffset = img_offset_x / 16 + c;
  var yOffset = img_offset_y / 16 + r;
  // log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v" + DATA_ENCODING_VERSION + "|" + xOffset + "," + yOffset + "|" + colors.join(',') + "|" + bid + "|" + encodeURIComponent(url);
}

var localStorage = {
  setItem: function setItem(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      console.error('Failed to set localstorage item', e);
    }
  },
  getItem: function getItem(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      console.error('Failed to get localstorage item', e);
    }
  },
  removeItem: function removeItem(key) {
    try {
      window.localStorage.removeItem(key);
    } catch (e) {
      console.error('Failed to remove localstorage item', e);
    }
  }
};

var BASE_S3_BUCKET = "https://millionbithomepage.com/static/billboard/";
var BASE_S3_BUCKET_TRX = "https://millionbithomepage.com/trx/";
// Billboard files only change when the server repaints, and it invalidates
// CloudFront when it does. Keying them to the current minute (instead of every
// millisecond) lets the browser reuse them while navigating between pages, at
// the cost of seeing a new plot up to a minute later.
var CACHE_WINDOW_MS = 60 * 1000;
var cacheKey = function cacheKey() {
  var key = Math.floor(Date.now() / CACHE_WINDOW_MS);
  // index.html preloads the billboard with the key of the minute the page
  // opened; keep using it into the next minute so that download isn't wasted.
  var preloaded = window.__billboardKey;
  return preloaded && key - preloaded <= 1 ? preloaded : key;
};
var getTsPath = function getTsPath(path) {
  return '' + BASE_S3_BUCKET + path + '?' + cacheKey();
};
// Bypasses the browser cache entirely, for an explicit reload.
var getFreshPath = function getFreshPath(path) {
  return '' + BASE_S3_BUCKET + path + '?' + Date.now();
};

/* harmony default export */ __webpack_exports__["a"] = ({
  escapeHtml: escapeHtml,
  safeUrl: safeUrl,
  getTsPath: getTsPath,
  getFreshPath: getFreshPath,
  cacheKey: cacheKey,
  localStorage: localStorage,
  getHexFromRgb: getHexFromRgb,
  getPixelsData: getPixelsData,
  stringDataForEth: stringDataForEth,
  convertReverseNodeToBytes: convertReverseNodeToBytes,
  truncateString: function truncateString(str) {
    return str.substring(0, 6) + '...' + str.substring(str.length - 4);
  },
  trackEvent: function trackEvent(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    try {
      if (window.umami) {
        window.umami.track(t, params);
      }
    } catch (e) {
      console.error('Failed to track event', e);
    }
  },

  replaceTransparent: function replaceTransparent(myImageData) {
    for (var i = 0, n = myImageData.length; i < n; i += 4) {
      // var r = myImageData[i],
      //     g = myImageData[i+1],
      //     b = myImageData[i+2],
      //     a = myImageData[i+3]

      // Completely transparent
      if (myImageData[i + 3] === 0) {
        // Set to solid white
        myImageData[i] = 255;
        myImageData[i + 1] = 255;
        myImageData[i + 2] = 255;
        myImageData[i + 3] = 255;
      }
    }
  },
  clearDraggableImage: function clearDraggableImage() {
    // Clear the draggable image from the page
    var uploadedImgCanvas = document.getElementById("uploadedImg");
    var uploadedImgCtx = uploadedImgCanvas.getContext("2d");
    uploadedImgCtx.clearRect(0, 0, uploadedImgCanvas.width, uploadedImgCanvas.height);
    uploadedImgCanvas.style.display = 'none';
  },
  confetti: function confetti(partyTime) {

    var Confettiful = function Confettiful(el) {
      document.querySelector('.confetti-wrapper').style.display = 'block';
      this.el = el;
      this.containerEl = null;

      this.confettiFrequency = 3;
      this.confettiColors = ['#ff0000', '#00ff00', '#0000ff', '#00ffff', '#ff00ff', '#ffff00'];
      this.confettiAnimations = ['slow', 'medium', 'fast'];

      this._setupElements();
      this._renderConfetti();
    };

    Confettiful.prototype._setupElements = function () {
      var containerEl = document.createElement('div');
      var elPosition = this.el.style.position;

      if (elPosition !== 'relative' || elPosition !== 'absolute') {
        this.el.style.position = 'relative';
      }

      containerEl.classList.add('confetti-container');

      this.el.appendChild(containerEl);

      this.containerEl = containerEl;
    };

    Confettiful.prototype._renderConfetti = function () {
      var _this = this;

      this.confettiInterval = setInterval(function () {
        var confettiEl = document.createElement('div');
        var confettiSize = Math.floor(Math.random() * 3) + 12 + 'px';
        var confettiBackground = _this.confettiColors[Math.floor(Math.random() * _this.confettiColors.length)];
        var confettiLeft = Math.floor(Math.random() * _this.el.offsetWidth) + 'px';
        var confettiAnimation = _this.confettiAnimations[Math.floor(Math.random() * _this.confettiAnimations.length)];

        confettiEl.classList.add('confetti', 'confetti--animation-' + confettiAnimation);
        confettiEl.style.left = confettiLeft;
        confettiEl.style.width = confettiSize;
        confettiEl.style.height = confettiSize;
        confettiEl.style.backgroundColor = confettiBackground;

        confettiEl.removeTimeout = setTimeout(function () {
          confettiEl.parentNode.removeChild(confettiEl);
        }, 3000);

        _this.containerEl.appendChild(confettiEl);
      }, 25);
    };
    Confettiful.prototype.stop = function () {
      // this.el.display = 'none';
      document.querySelector('.confetti-wrapper').style.display = 'none';
      clearInterval(this.confettiInterval);
    };

    window.confettiful = new Confettiful(document.querySelector('.js-container'));

    setTimeout(function () {
      window.confettiful.stop();
    }, partyTime);
  },
  toast: toast,
  isMobileOrTouch: isMobileOrTouch,
  wait: function wait(ms) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(resolve, ms);
    });
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iaho");
function injectStyle (ssrContext) {
  __webpack_require__("yA2K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__("L/hj");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








if (window.Sentry) {
  Sentry.onLoad(function () {
    Sentry.init({
      // Performance Monitoring
      tracesSampleRate: 1.0, // Capture 100% of the transactions
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  });
}

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);

// Template helper: href for user-supplied URLs (undefined unless http/https).
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$safeUrl = __WEBPACK_IMPORTED_MODULE_7__utils__["a" /* default */].safeUrl;

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].directive('lazy-load', {
  inserted: function inserted(el) {
    function loadImage() {
      var imageElement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(el.children).find(function (el) {
        return el.nodeName === "IMG";
      });
      if (imageElement) {
        imageElement.addEventListener('load', function () {
          setTimeout(function () {
            return el.classList.add('loaded');
          }, 100);
        });
        imageElement.addEventListener('error', function () {
          return console.log('error');
        });
        imageElement.src = imageElement.dataset.url;
      }
    }

    function handleIntersect(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadImage();
          observer.unobserve(el);
        }
      });
    }

    function createObserver() {
      var options = {
        root: null,
        threshold: "0"
      };
      var observer = new IntersectionObserver(handleIntersect, options);
      observer.observe(el);
    }

    if (window["IntersectionObserver"]) {
      createObserver();
    } else {
      loadImage();
    }
  }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] }
});

/***/ }),

/***/ "Qfom":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("KlKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e55d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("pEEw");
function injectStyle (ssrContext) {
  __webpack_require__("AlKc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59e55d30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59e55d30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
    // Feature flags
    SHOW_REWARDS: false, // Set to true to show the Rewards section on /plots page

    WEBHOOK_URL: 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/',
    NFT_CA: '0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e',
    NFT_ABI: __webpack_require__("lxEZ"),
    NFT_REWARDS_CA: '0x262457Ad3F751C7027C5e632e862cabf497bC082', // 0x134C638F1c44a06000a4A3738A0dD34BA9e47070
    NFT_REWARDS_ABI: __webpack_require__("qlaW"),
    // [
    //     {
    //         "inputs": [{"internalType": "uint256", "name": "tokenId", "type": "uint256"}],
    //         "name": "getTokenIdAllocation",
    //         "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    //         "stateMutability": "view",
    //         "type": "function"
    //     },
    //     {
    //         "inputs": [
    //             {"internalType": "address", "name": "wallet", "type": "address"},
    //             {"internalType": "uint256[]", "name": "tokenIds", "type": "uint256[]"}
    //         ],
    //         "name": "claimAllocation",
    //         "outputs": [],
    //         "stateMutability": "nonpayable",
    //         "type": "function"
    //     },
    //     {
    //         "anonymous": false,
    //         "inputs": [
    //             {"indexed": true, "internalType": "address", "name": "wallet", "type": "address"},
    //             {"indexed": true, "internalType": "uint256", "name": "tokenId", "type": "uint256"},
    //             {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"}
    //         ],
    //         "name": "RewardClaimed",
    //         "type": "event"
    //     }
    // ],
    TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
    TANG_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
    NFT_TANG_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90',
    SUBPAGES: {
        TANG: {
            TOKEN_CA: '0xCC3ABa72BB8D3e38745b4FB9941141a85B3b1fd8',
            NFT_CA: '0xf9257167ea5f0bffd4f1c727a2c35a00ac1dea90'
        },
        DOB: {
            TOKEN_CA: '0x0B7056f5e82B254D93BD9A1C860ff069340f347f',
            NFT_CA: '0xdd49c98ba4308ce2c6d11cc37a9040827096bee7'
        },
        PREME: {
            TOKEN_CA: '0x6e1307cb2e16e53718d9a69026c14a4dd1ee2e24',
            NFT_CA: '0x79bd982be6446be8d42497c149b2efe4d3e1f53d',
            canUseEth: true
        },
        ZORA: {
            TOKEN_CA: '0x5ca35371263CA25e0BC8005fB44e0c37D0a0BdfD', // 0x6a994a26d713564a9453c24859585f860f129a96
            NFT_CA: '0x1b56eda8dfd245b5d336cc145f49afb4e1fc426a', // 0xef15adef3e3d321dde5c378f16f3e71ba6c6a0fe
            canUseEth: false
        }
    },
    TOKEN_ABI: __webpack_require__("BEit"),
    LOCAL_STORAGE_KEYS: {
        NEWSLETTER_SUBSCRIBED: 'NEWSLETTER_SUBSCRIBED'
    }
};
/* harmony default export */ __webpack_exports__["a"] = (config);

// const transferABI = [
//     // {
//     //   name: "transfer",
//     //   type: "function",
//     //   inputs: [
//     //     {
//     //       name: "_to",
//     //       type: "address",
//     //     },
//     //     {
//     //       type: "uint256",
//     //       name: "_tokens",
//     //     },
//     //   ],
//     //   constant: false,
//     //   outputs: [],
//     //   payable: false,
//     // },
//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "to",
//           "type": "address"
//         },
//         {
//           "internalType": "uint256",
//           "name": "value",
//           "type": "uint256"
//         },
//         {
//           "internalType": "string",
//           "name": "paintData",
//           "type": "string"
//         }
//       ],
//       "name": "paint",
//       "outputs": [
//         {
//           "internalType": "bool",
//           "name": "",
//           "type": "bool"
//         }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },

//     {
//       "inputs": [
//         {
//           "internalType": "address",
//           "name": "owner",
//           "type": "address"
//         }
//       ],
//       "name": "balanceOf",
//       "outputs": [
//         {
//           "internalType": "uint256",
//           "name": "",
//           "type": "uint256"
//         }
//       ],
//       "stateMutability": "view",
//       "type": "function"
//     },
//     {
//       "inputs": [
//           {
//               "internalType": "address",
//               "name": "spender",
//               "type": "address"
//           },
//           {
//               "internalType": "uint256",
//               "name": "value",
//               "type": "uint256"
//           }
//       ],
//       "name": "approve",
//       "outputs": [
//           {
//               "internalType": "bool",
//               "name": "",
//               "type": "bool"
//           }
//       ],
//       "stateMutability": "nonpayable",
//       "type": "function"
//     },
//   ];

/***/ }),

/***/ "SYh3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Homepage__ = __webpack_require__("Qfom");


// The homepage ships in the main bundle; every other route loads on demand.

var Transactions = function Transactions() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "NZaW"));
};
var Leaderboard = function Leaderboard() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "Fvhm"));
};
var Break = function Break() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "5lUk"));
};
var Drop = function Drop() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "MjUn"));
};
var Circles = function Circles() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "DpKw"));
};
var About = function About() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "c27y"));
};
var Menu = function Menu() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "ccZh"));
};
var Plots = function Plots() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "1MwN"));
};
var Spaces = function Spaces() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "eWOI"));
};
var Demo = function Demo() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "26cW"));
};
var Terms = function Terms() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Rp40"));
};
var Privacy = function Privacy() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "8mQd"));
};
var Subscribe = function Subscribe() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "YTo8"));
};
var Tang = function Tang() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "8DXe"));
};
var Dob = function Dob() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "FIYo"));
};
var Preme = function Preme() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "fqzV"));
};
var Zora = function Zora() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "hHLD"));
};
var Plot = function Plot() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "VNv2"));
};
var Agents = function Agents() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Z7qf"));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history', // routes without the hash
  routes: [{
    path: '/',
    name: 'homepage',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Homepage__["a" /* default */],
    meta: {
      title: 'Million Bit Homepage'
    }
  }, {
    path: '/list',
    name: 'list',
    component: Transactions,
    meta: {
      title: 'Million Bit List'
    }
  }, {
    path: '/leaderboard',
    name: 'leaderboard',
    component: Leaderboard,
    meta: {
      title: 'Million Bit Leaderboard'
    }
  }, {
    path: '/break',
    name: 'break',
    component: Break,
    meta: {
      title: 'Million Bit Break'
    }
  }, {
    path: '/drop',
    name: 'drop',
    component: Drop,
    meta: {
      title: 'Million Bit Drop'
    }
  }, {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      title: 'About the Million Bit Homepage'
    }
  }, {
    path: '/menu',
    name: 'nav-menu',
    component: Menu,
    meta: {
      title: 'Million Bit Menu'
    }
  }, {
    path: '/demo',
    name: 'nav-demo',
    component: Demo,
    meta: {
      title: 'Million Bit Homepage Demo'
    }
  }, {
    path: '/plots',
    name: 'plots',
    component: Plots,
    meta: {
      title: 'Million Bit Homepage Plots'
    }
  }, {
    path: '/spaces',
    name: 'spaces',
    component: Spaces,
    meta: {
      title: 'Based Spaces'
    }
  }, {
    path: '/terms',
    name: 'terms',
    component: Terms,
    meta: {
      title: 'Million Bit Homepage - Terms of Service'
    }
  }, {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: {
      title: 'Million Bit Homepage - Privacy Policy'
    }
  }, {
    path: '/subscribe',
    name: 'subscribe',
    component: Subscribe,
    meta: {
      title: 'Subscribe to the Million Bit Homepage'
    }
  }, {
    path: '/tang',
    name: 'tang',
    component: Tang,
    meta: {
      title: 'Tang Tree powered by the Million Bit Homepage'
    }
  }, {
    path: '/dob',
    name: 'dob',
    component: Dob,
    meta: {
      title: 'DOB Pixel Gallery powered by the Million Bit Homepage'
    }
  }, {
    path: '/preme',
    name: 'preme',
    component: Preme,
    meta: {
      title: 'Preme Bit Page powered by the Million Bit Homepage'
    }
  }, {
    path: '/zora',
    name: 'zora',
    component: Zora,
    meta: {
      title: 'Million Zora Post powered by the Million Bit Homepage'
    }
  }, {
    path: '/circles',
    name: 'circles',
    component: Circles,
    meta: {
      title: 'Million Circles'
    }
  }, {
    path: '/plot/:id',
    name: 'plot',
    component: Plot,
    meta: {
      title: 'Plot Details - Million Bit Homepage'
    }
  }, {
    path: '/agents',
    name: 'agents',
    component: Agents,
    meta: {
      title: 'Agents - Million Bit Homepage'
    }
  }, {
    path: '*', // Catch-all for undefined paths in the new mode
    redirect: '/' // Redirect to home or any other default route
  }]
});

router.beforeEach(function (to, from, next) {
  // Access the title from the route's meta field
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'Million Bit Homepage'; // Fallback title
  }
  next(); // Proceed to the route
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "iaho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('b-navbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": _vm.variant
    }
  }, [_c('div', {
    staticClass: "header-l mr-auto nav-menu text-left"
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-nav-form', {
    staticStyle: {
      "display": "block !important"
    }
  }, [_c('span', {
    staticClass: "btn-group nav-buttons"
  }, [(!_vm.whiteLabel) ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/menu')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-list",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.whiteLabel) ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-intro",
      modifiers: {
        "modal-intro": true
      }
    }],
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    }
  }, [_c('svg', {
    staticClass: "bi bi-question-circle",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286m1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/' || _vm.$route.path === '/tang' || _vm.$route.path === '/dob' || _vm.$route.path === '/preme' || _vm.$route.path === '/zora') ? _c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doUpload()
      }
    }
  }, [_vm._v("\n                UPLOAD \n                ")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy && _vm.$route.path === '/' && _vm.connectAccountEnsAvatar != '') ? _c('b-button', {
    staticClass: "btn-icon",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": _vm.doUploadAvatar
    }
  }, [_c('img', {
    staticClass: "ensAvatar",
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mr-0 p-0 header-m"
  }, [(!_vm.whiteLabel) ? _c('span', {
    staticClass: "honk-text mbh-title",
    on: {
      "click": function($event) {
        return _vm.navigateTo('/')
      }
    }
  }, [_vm._v("Million Bit Homepage")]) : _vm._e(), _vm._v(" "), (!_vm.canBuy) ? _c('p', {
    staticClass: "subtitle dm-sans-text"
  }, [_vm._v("\n        1,000,000 pixels \n        • "), (_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethPerPixel)
    }
  }), _vm._v(" "), _c('span', [_vm._v("ETH")])]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenPerPixel)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e(), _vm._v("\n         per pixel \n        • Own a bit of onchain history!\n      ")]) : _vm._e(), _vm._v(" "), (_vm.canBuy) ? _c('div', {
    staticClass: "d-block text-center mb-3"
  }, [_c('b-nav-form', {
    staticClass: "text-center"
  }, [(_vm.canToggleEthToken) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    class: {
      'btn-outline-lighter': !_vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(true)
      }
    }
  }, [_c('span', [_vm._v("ETH")])]), _vm._v(" "), _c('b-button', {
    class: {
      'btn-outline-lighter': _vm.ethTokenToggle
    },
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doToggleEthToken(false)
      }
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "disabled": ""
    }
  }, [(_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.ethAmtFormatted)
    }
  }), _vm._v(" ETH")]) : _vm._e(), _vm._v(" "), (!_vm.ethTokenToggle) ? _c('span', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.tokenAmt)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('b-form-input', {
    ref: "formInputValueUrl",
    staticClass: "mr-md-2",
    attrs: {
      "size": "md",
      "placeholder": "http link address",
      "type": "url",
      "id": "link-url",
      "value": _vm.formInputUrl
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.blurInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.canSend) ? _c('b-button', {
    attrs: {
      "variant": "warning",
      "disabled": _vm.buyLoading
    },
    on: {
      "click": _vm.doBuy
    }
  }, [_c('span', [(_vm.buyLoading) ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _vm._v(" "), (_vm.canMint) ? _c('span', [_vm._v("MINT")]) : _c('span', [_vm._v("SEND")])])]) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-r ml-auto connect-menu text-right"
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "connect-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.connectWallet()
      }
    }
  }, [_vm._v("\n        Connect Wallet\n      ")]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', {
    staticClass: "btn-group"
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('/plots')
      }
    }
  }, [(_vm.connectAccountEnsAvatar) ? _c('span', [_c('img', {
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.connectAccountEnsAvatar
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountEnsNameTrunc)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.connectAccountEnsName) ? _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.connectAccountAddressTrunc)
    }
  }) : _vm._e()]), _vm._v(" "), _c('b-button', {
    staticClass: "disconnect",
    attrs: {
      "variant": _vm.variantNavButton
    },
    on: {
      "click": function($event) {
        return _vm.doDisconnect()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-box-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress && !_vm.isBaseChain(_vm.connectAccountChainId)) ? _c('div', {
    staticClass: "my-2"
  }, [_c('b-button', {
    attrs: {
      "variant": 'warning'
    },
    on: {
      "click": function($event) {
        return _vm.switchToBaseChain()
      }
    }
  }, [_vm._v("Switch to Base")])], 1) : _vm._e()], 1)]), _vm._v(" "), (_vm.rewardsMsg) ? _c('div', {
    staticClass: "rewards-header"
  }, [_vm._v("\n    " + _vm._s(_vm.rewardsMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.showPromo) ? _c('div', {
    staticClass: "promo-header"
  }, [_vm._v("\n    " + _vm._s(_vm.promoMsg) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('router-view', {
    ref: "routerViewRef"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame && !_vm.isZora),
      expression: "!isGame && !isZora"
    }],
    staticClass: "mb-5",
    attrs: {
      "id": "countdown"
    }
  }, [(!_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Pixel price goes up with each minted plot!")]) : _vm._e(), _vm._v(" "), (_vm.whiteLabel) ? _c('p', {
    staticClass: "text-bold"
  }, [_vm._v("Powered by the "), _c('a', {
    attrs: {
      "href": "https://millionbithomepage.com",
      "target": "_blank"
    }
  }, [_vm._v("Million Bit Homepage")])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-connect",
      "title": "Connect your wallet",
      "hide-footer": "",
      "size": "sm"
    }
  }, [(!_vm.connectAccountAddress) ? _c('b-button', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "id": "create-wallet",
      "variant": 'connect'
    },
    on: {
      "click": function($event) {
        return _vm.createWallet()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v("\n       Create Wallet\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkMetamask,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,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"
    }
  }), _vm._v(" Metamask")]) : _vm._e(), _vm._v(" "), (!_vm.connectAccountAddress && _vm.providers.length === 0) ? _c('a', {
    staticClass: "btn btn-block btn-primary mb-4",
    attrs: {
      "href": _vm.deepLinkCoinbase,
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+"
    }
  }), _vm._v(" Coinbase")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.providers), function(provider) {
    return _c('span', [(!_vm.connectAccountAddress) ? _c('b-button', {
      staticClass: "btn-block btn-primary mb-4",
      attrs: {
        "variant": 'connect',
        "disabled": _vm.isConnecting
      },
      on: {
        "click": function($event) {
          return _vm.doConnect(provider)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": provider.info.icon
      }
    }), _vm._v(" " + _vm._s(provider.info.name) + "\n      ")]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-token",
      "title": "Own a bit of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "2",
      "viewBox": "0 0 24 24",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "height": "1em",
      "width": "1em",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "width": "14",
      "height": "14",
      "x": "8",
      "y": "8",
      "rx": "2",
      "ry": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
    }
  })]), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.contractAddress)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.contractAddress)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-outline-dark btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.watchToken()
      }
    }
  }, [_vm._v("Watch token in wallet")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h2', [_vm._v("Launch status")]), _vm._v(" "), _c('p', [_vm._v("Coming soon.. join us on telegram for updates on the upcoming launch!")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-alert",
      "hide-header": "",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.alertMsg)
    }
  }), _vm._v(" "), (_vm.alertSwapOpts && _vm.alertSwapOpts.amountNeeded) ? _c('div', [_c('h5', {
    staticClass: "text-center m-2"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.alertSwapOpts.amountNeededFormatted)
    }
  }), _vm._v(" more "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" needed to mint your plot.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group btn-block"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.doSwap(_vm.alertSwapOpts.amountNeeded)
      }
    }
  }, [_vm._v("\n          SWAP\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "external-link m-0 btn btn-block btn-primary btn-lg",
    staticStyle: {
      "max-width": "100px"
    },
    attrs: {
      "href": "https://app.uniswap.org/swap?outputCurrency=0x5ca35371263CA25e0BC8005fB44e0c37D0a0BdfD&chain=base",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "20px"
    },
    attrs: {
      "src": "/static/external-link.svg",
      "alt": "Swap on Uniswap"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-swap",
      "hide-header": "",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h1', [_vm._v("Swap")]), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    domProps: {
      "textContent": _vm._s(_vm.alertMsg)
    }
  }), _vm._v(" "), (_vm.alertSwapOpts && _vm.alertSwapOpts.amountNeeded) ? _c('div', [_c('h5', {
    staticClass: "text-center m-2"
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.alertSwapOpts.amountNeededFormatted)
    }
  }), _vm._v(" more "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.symbol)
    }
  }), _vm._v(" needed to mint your plot.")]), _vm._v(" "), _c('br'), _vm._v("\n      eth\n      million zora post\n      "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    on: {
      "click": function($event) {
        return _vm.doSwap(_vm.alertSwapOpts.amountNeeded)
      }
    }
  }, [_vm._v("\n          SWAP\n        ")])])]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-intro",
      "title": "👋 Welcome to the Million Bit Homepage!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Add your image to the homepage and be forever immortalized on the blockchain!\n    ")]), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("💰 What you get")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("NFT of your plot!")]), _vm._v("\n      You own your plot forever. List it on \n      "), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://magiceden.us/collections/base/0x25b9afe64bb3593ec7e9dc7ef386a9b04c53f96e",
      "target": "_blank"
    }
  }, [_vm._v("Magic Eden")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/plots')
      }
    }
  }, [_vm._v("update your plot")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Earn rewards for your NFTs.")]), _vm._v("\n      Get rewarded for the pixels you've minted.\n      "), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/plots')
      }
    }
  }, [_vm._v("Claim now")]), _vm._v(".\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Join the MBH community.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/spaces')
      }
    }
  }, [_vm._v("Twitter X spaces")]), _vm._v(" and access to our exclusive Twitter X group.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v("Included in marketing and games.")]), _vm._v("\n      Instantly included in our games "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/break')
      }
    }
  }, [_vm._v("Break")]), _vm._v(" & "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/drop')
      }
    }
  }, [_vm._v("Drop")]), _vm._v(".\n      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("👩‍🏫 How it works")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 1")]), _vm._v(" \n      Click on the UPLOAD button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 2")]), _vm._v(" \n      Move and resize your image.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 3")]), _vm._v(" \n      Click the MINT button.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b', {
    staticClass: "pr-2"
  }, [_vm._v("Step 4")]), _vm._v(" \n      Check back in a minute to see your addition!\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "my-4"
  }, [_vm._v("📽️ See it in action")]), _vm._v(" "), _c('p', [_vm._v("\n      Watch an example of how easy it is to claim your plot on the homepage.\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('demo')
      }
    }
  }, [_vm._v("Watch video")])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-success",
      "title": "You're a part of blockchain history!",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('p', [_vm._v("\n      Thank you for being a part of blockchain history 💙\n      "), _c('br'), (_vm.trxHashSuccess) ? _c('a', {
    attrs: {
      "href": 'https://basescan.org/tx/' + _vm.trxHashSuccess,
      "target": "_blank"
    }
  }, [_vm._v("View transaction")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Please allow a few minutes to process your pixels from the blockchain and be added to the "), (!_vm.whiteLabel && !_vm.isZora) ? _c('span', [_vm._v("homepage")]) : _vm._e(), (_vm.whiteLabel || _vm.isZora) ? _c('span', [_vm._v("page")]) : _vm._e(), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v("\n      Make sure to join our community on "), _c('a', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank"
    }
  }, [_vm._v("Telegram")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank"
    }
  }, [_vm._v("Twitter")]), _vm._v(".\n      "), _c('br'), _c('br'), _vm._v(" "), (!_vm.whiteLabel && !_vm.isZora) ? _c('span', [_vm._v("Share the Million Bit Homepage with your friends!\n      "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostSuccess,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "modal-invite-friends",
      "title": "Invite Friends",
      "hide-footer": "",
      "size": "lg"
    }
  }, [_c('h1', [_vm._v("Refer your friends!")]), _vm._v(" "), _c('p', [_vm._v("\n      Share the Million Bit Homepage with your friends!\n    ")]), _vm._v(" "), (!_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Connect your wallet to get your referral link")])]) : _vm._e(), _vm._v(" "), (_vm.connectAccountAddress) ? _c('span', [_c('b', [_vm._v("Share invite link")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-outline-dark btn-lg",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.shareUrl)
    },
    on: {
      "click": function($event) {
        return _vm.doCopyToClipboard(_vm.shareUrl)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-block btn-lg btn-primary",
    attrs: {
      "href": _vm.xPostInvite,
      "target": "_blank"
    }
  }, [_vm._v("Share on X")]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "fine-uploader-manual-trigger"
    }
  }), _vm._v(" "), (_vm.isMobileOrTouch && _vm.canBuy) ? _c('div', {
    attrs: {
      "id": "mobile-controls"
    }
  }, [_c('div', {
    attrs: {
      "id": "control-down"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'down')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-down",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-left"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'left')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-left",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-right"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'right')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-right",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-up"
    },
    on: {
      "click": _vm.btnPress,
      "touchstart": function($event) {
        return _vm.handleTouchStart($event, 'up')
      },
      "touchend": _vm.handleTouchEnd,
      "touchcancel": _vm.handleTouchCancel
    }
  }, [_c('svg', {
    staticClass: "bi bi-arrow-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-smaller"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('smaller')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-out",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "control-bigger"
    },
    on: {
      "click": function($event) {
        return _vm.resizeSpot('bigger')
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-zoom-in",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isGame),
      expression: "!isGame"
    }],
    staticClass: "bg-white mbh-footer"
  }, [_c('b-navbar', {
    attrs: {
      "variant": "white"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "honk-text"
  }, [_vm._v("MBH")])]), _vm._v(" "), _c('b-navbar-nav', [_c('b-nav-item', {
    attrs: {
      "href": _vm.email,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-envelope",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.telegram,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })])]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "href": _vm.twitter,
      "target": "_blank",
      "variant": "link"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })])]), _vm._v(" "), (false) ? _c('b-nav-item', {
    staticClass: "send-feedback",
    attrs: {
      "variant": "link",
      "href": "https://www.complainonchain.xyz/millionbithomepage",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/keren.webp"
    }
  }), _vm._v(" Feedback")]) : _vm._e(), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showInviteFriends()
      }
    }
  }, [_c('svg', {
    staticClass: "bi bi-megaphone-fill",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25 25 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009l.496.008a64 64 0 0 1 1.51.048m1.39 1.081q.428.032.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a66 66 0 0 1 1.692.064q.491.026.966.06"
    }
  })]), _vm._v("\n        Invite friends\n      ")])], 1), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/agents')
      }
    }
  }, [_vm._v("Agents")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/terms')
      }
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.navigateTo('/privacy')
      }
    }
  }, [_vm._v("Privacy")])], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": "",
      "variant": "link",
      "id": "copyright"
    }
  }, [_vm._v("© 2025. All rights reserved. Not responsible for the content of external sites or images featured which are © of their respective owners.")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toast"
    }
  }), _vm._v(" "), (!_vm.watchedDemo && !_vm.whiteLabel && !_vm.isZora) ? _c('div', {
    attrs: {
      "id": "pfp-vid-container"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDemoVideo.apply(null, arguments)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": "pfp-vid"
    }
  }, [(_vm.pfpVidSrc) ? _c('video', {
    attrs: {
      "src": _vm.pfpVidSrc,
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": ""
    },
    domProps: {
      "muted": true
    }
  }) : _vm._e()])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confetti-wrapper"
  }, [_c('div', {
    staticClass: "js-container c-container"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lxEZ":
/***/ (function(module, exports) {

module.exports = [{"inputs":[{"internalType":"address","name":"initialOwner","type":"address"},{"internalType":"address","name":"minterAddress","type":"address"},{"internalType":"address payable","name":"royaltyRecipientAddress","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"ERC721EnumerableForbiddenBatchMint","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721IncorrectOwner","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721InsufficientApproval","type":"error"},{"inputs":[{"internalType":"address","name":"approver","type":"address"}],"name":"ERC721InvalidApprover","type":"error"},{"inputs":[{"internalType":"address","name":"operator","type":"address"}],"name":"ERC721InvalidOperator","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"ERC721InvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"receiver","type":"address"}],"name":"ERC721InvalidReceiver","type":"error"},{"inputs":[{"internalType":"address","name":"sender","type":"address"}],"name":"ERC721InvalidSender","type":"error"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ERC721NonexistentToken","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"ERC721OutOfBoundsIndex","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_fromTokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"_toTokenId","type":"uint256"}],"name":"BatchMetadataUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"MetadataUpdate","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"string","name":"pixelStr","type":"string"}],"name":"PixelDataLogged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"basePrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burnToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"}],"name":"calculateCurrentPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"}],"name":"checkOverlap","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"mint","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"uri","type":"string"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"ownerMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"priceIncrement","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"repaintPixels","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"repaintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"salePrice","type":"uint256"}],"name":"royaltyInfo","outputs":[{"internalType":"address","name":"receiver","type":"address"},{"internalType":"uint256","name":"royaltyAmount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"royaltyPercentage","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"royaltyRecipient","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_basePrice","type":"uint256"}],"name":"setBasePrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"bool","name":"isOccupied","type":"bool"}],"name":"setCoordsOccupied","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"minterAddress","type":"address"}],"name":"setMinterAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_priceIncrement","type":"uint256"}],"name":"setPriceIncrement","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_repaintPrice","type":"uint256"}],"name":"setRepaintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"royaltyRecipientAddress","type":"address"}],"name":"setRoyaltyAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_percentage","type":"uint256"}],"name":"setRoyaltyPercentage","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_tokenAddress","type":"address"}],"name":"setTokenAddress","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenRepaintPrice","type":"uint256"}],"name":"setTokenRepaintPrice","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"tokenAddress","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint16","name":"x1","type":"uint16"},{"internalType":"uint16","name":"y1","type":"uint16"},{"internalType":"uint16","name":"x2","type":"uint16"},{"internalType":"uint16","name":"y2","type":"uint16"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"tokenMint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"pixelStr","type":"string"}],"name":"tokenRepaintPixels","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"tokenRepaintPrice","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"string","name":"newUri","type":"string"}],"name":"updateTokenURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}]

/***/ }),

/***/ "oiih":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var L2ResolverAbi = [{
  inputs: [{
    internalType: 'contract ENS',
    name: 'ens_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'registrarController_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'reverseRegistrar_',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'owner_',
    type: 'address'
  }],
  stateMutability: 'nonpayable',
  type: 'constructor'
}, {
  inputs: [],
  name: 'AlreadyInitialized',
  type: 'error'
}, {
  inputs: [],
  name: 'CantSetSelfAsDelegate',
  type: 'error'
}, {
  inputs: [],
  name: 'CantSetSelfAsOperator',
  type: 'error'
}, {
  inputs: [],
  name: 'NewOwnerIsZeroAddress',
  type: 'error'
}, {
  inputs: [],
  name: 'NoHandoverRequest',
  type: 'error'
}, {
  inputs: [],
  name: 'Unauthorized',
  type: 'error'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'uint256',
    name: 'contentType',
    type: 'uint256'
  }],
  name: 'ABIChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'a',
    type: 'address'
  }],
  name: 'AddrChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'newAddress',
    type: 'bytes'
  }],
  name: 'AddressChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    indexed: false,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'ApprovalForAll',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'Approved',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'ContenthashChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'name',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'record',
    type: 'bytes'
  }],
  name: 'DNSRecordChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'name',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }],
  name: 'DNSRecordDeleted',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'lastzonehash',
    type: 'bytes'
  }, {
    indexed: false,
    internalType: 'bytes',
    name: 'zonehash',
    type: 'bytes'
  }],
  name: 'DNSZonehashChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }, {
    indexed: false,
    internalType: 'address',
    name: 'implementer',
    type: 'address'
  }],
  name: 'InterfaceChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'name',
    type: 'string'
  }],
  name: 'NameChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'OwnershipHandoverCanceled',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'OwnershipHandoverRequested',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'oldOwner',
    type: 'address'
  }, {
    indexed: true,
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'OwnershipTransferred',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  name: 'PubkeyChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'newRegistrarController',
    type: 'address'
  }],
  name: 'RegistrarControllerUpdated',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'address',
    name: 'newReverseRegistrar',
    type: 'address'
  }],
  name: 'ReverseRegistrarUpdated',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: true,
    internalType: 'string',
    name: 'indexedKey',
    type: 'string'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'key',
    type: 'string'
  }, {
    indexed: false,
    internalType: 'string',
    name: 'value',
    type: 'string'
  }],
  name: 'TextChanged',
  type: 'event'
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    indexed: false,
    internalType: 'uint64',
    name: 'newVersion',
    type: 'uint64'
  }],
  name: 'VersionChanged',
  type: 'event'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'contentTypes',
    type: 'uint256'
  }],
  name: 'ABI',
  outputs: [{
    internalType: 'uint256',
    name: '',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'addr',
  outputs: [{
    internalType: 'address payable',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }],
  name: 'addr',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'approve',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [],
  name: 'cancelOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'clearRecords',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'completeOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'contenthash',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'name',
    type: 'bytes32'
  }, {
    internalType: 'uint16',
    name: 'resource',
    type: 'uint16'
  }],
  name: 'dnsRecord',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'ens',
  outputs: [{
    internalType: 'contract ENS',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'name',
    type: 'bytes32'
  }],
  name: 'hasDNSRecords',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }],
  name: 'interfaceImplementer',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'owner',
    type: 'address'
  }, {
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'delegate',
    type: 'address'
  }],
  name: 'isApprovedFor',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'account',
    type: 'address'
  }, {
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }],
  name: 'isApprovedForAll',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes[]',
    name: 'data',
    type: 'bytes[]'
  }],
  name: 'multicall',
  outputs: [{
    internalType: 'bytes[]',
    name: 'results',
    type: 'bytes[]'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'nodehash',
    type: 'bytes32'
  }, {
    internalType: 'bytes[]',
    name: 'data',
    type: 'bytes[]'
  }],
  name: 'multicallWithNodeCheck',
  outputs: [{
    internalType: 'bytes[]',
    name: 'results',
    type: 'bytes[]'
  }],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'name',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'owner',
  outputs: [{
    internalType: 'address',
    name: 'result',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'pendingOwner',
    type: 'address'
  }],
  name: 'ownershipHandoverExpiresAt',
  outputs: [{
    internalType: 'uint256',
    name: 'result',
    type: 'uint256'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'pubkey',
  outputs: [{
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: '',
    type: 'bytes32'
  }],
  name: 'recordVersions',
  outputs: [{
    internalType: 'uint64',
    name: '',
    type: 'uint64'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'registrarController',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'renounceOwnership',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [],
  name: 'requestOwnershipHandover',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'resolve',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [],
  name: 'reverseRegistrar',
  outputs: [{
    internalType: 'address',
    name: '',
    type: 'address'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'contentType',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'setABI',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'uint256',
    name: 'coinType',
    type: 'uint256'
  }, {
    internalType: 'bytes',
    name: 'a',
    type: 'bytes'
  }],
  name: 'setAddr',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'address',
    name: 'a',
    type: 'address'
  }],
  name: 'setAddr',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'operator',
    type: 'address'
  }, {
    internalType: 'bool',
    name: 'approved',
    type: 'bool'
  }],
  name: 'setApprovalForAll',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'setContenthash',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'data',
    type: 'bytes'
  }],
  name: 'setDNSRecords',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }, {
    internalType: 'address',
    name: 'implementer',
    type: 'address'
  }],
  name: 'setInterface',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'newName',
    type: 'string'
  }],
  name: 'setName',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'x',
    type: 'bytes32'
  }, {
    internalType: 'bytes32',
    name: 'y',
    type: 'bytes32'
  }],
  name: 'setPubkey',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'registrarController_',
    type: 'address'
  }],
  name: 'setRegistrarController',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'reverseRegistrar_',
    type: 'address'
  }],
  name: 'setReverseRegistrar',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'key',
    type: 'string'
  }, {
    internalType: 'string',
    name: 'value',
    type: 'string'
  }],
  name: 'setText',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'bytes',
    name: 'hash',
    type: 'bytes'
  }],
  name: 'setZonehash',
  outputs: [],
  stateMutability: 'nonpayable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes4',
    name: 'interfaceID',
    type: 'bytes4'
  }],
  name: 'supportsInterface',
  outputs: [{
    internalType: 'bool',
    name: '',
    type: 'bool'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }, {
    internalType: 'string',
    name: 'key',
    type: 'string'
  }],
  name: 'text',
  outputs: [{
    internalType: 'string',
    name: '',
    type: 'string'
  }],
  stateMutability: 'view',
  type: 'function'
}, {
  inputs: [{
    internalType: 'address',
    name: 'newOwner',
    type: 'address'
  }],
  name: 'transferOwnership',
  outputs: [],
  stateMutability: 'payable',
  type: 'function'
}, {
  inputs: [{
    internalType: 'bytes32',
    name: 'node',
    type: 'bytes32'
  }],
  name: 'zonehash',
  outputs: [{
    internalType: 'bytes',
    name: '',
    type: 'bytes'
  }],
  stateMutability: 'view',
  type: 'function'
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  L2ResolverAbi: L2ResolverAbi
});

/***/ }),

/***/ "pEEw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "billboard",
    class: {
      'showTooltip': _vm.hovering
    },
    attrs: {
      "id": "million-bit-billboard"
    },
    on: {
      "click": _vm.clickBillboard,
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "mousemove": _vm.onMouseMove
    }
  }, [_c('canvas', {
    attrs: {
      "id": "uploadedImg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.s3ImgSrc,
      "usemap": "#linkmap"
    },
    on: {
      "load": _vm.onBillboardLoaded,
      "error": _vm.onBillboardError
    }
  }), _vm._v(" "), _c('map', {
    attrs: {
      "name": "linkmap"
    }
  }, _vm._l((_vm.links), function(link) {
    return _c('area', {
      attrs: {
        "target": "_blank",
        "alt": "",
        "title": "",
        "shape": "rect",
        "coords": link.c,
        "href": _vm.$safeUrl(link.u)
      }
    })
  }), 0), _vm._v(" "), _c('div', {
    ref: 'tooltip',
    attrs: {
      "id": "billboard-tooltip"
    }
  }), _vm._v(" "), (_vm.showVideo) ? _c('div', {
    staticClass: "homepage-animated"
  }, [_c('video', {
    attrs: {
      "id": "billboard-video",
      "src": _vm.s3VidSrc,
      "autoplay": "",
      "muted": "",
      "controls": ""
    },
    domProps: {
      "muted": true
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "btn-group m-3 honk-text"
  }, [(!_vm.showVideo) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.playVideo
    }
  }, [_vm._v("ANIMATE")]) : _vm._e(), _vm._v(" "), (_vm.showVideo) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.playVideo
    }
  }, [_vm._v("STOP 🛑")]) : _vm._e(), _vm._v(" "), (!_vm.inspectMode) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.toggleInspect
    }
  }, [_vm._v("INSPECT")]) : _vm._e(), _vm._v(" "), (_vm.inspectMode) ? _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": _vm.toggleInspect
    }
  }, [_vm._v("LINKS 🔗")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-outline-light",
    on: {
      "click": function($event) {
        return _vm.$router.push('/break')
      }
    }
  }, [_vm._v("BREAK 🕹️")])]), _vm._v(" "), (_vm.inspectMode && !_vm.inspectTrx) ? _c('div', {
    staticClass: "inspect-hint"
  }, [_vm._v("Select some pixels to inspect them")]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx) ? _c('div', {
    attrs: {
      "id": "plot-inspect"
    }
  }, [_c('div', {
    staticClass: "inspect-card"
  }, [_c('router-link', {
    staticClass: "inspect-image-link",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_c('img', {
    attrs: {
      "src": 'https://millionbithomepage.com/seq/' + _vm.inspectTrx.seq + '/token.jpeg'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inspect-details"
  }, [_c('div', {
    staticClass: "inspect-header"
  }, [_c('router-link', {
    staticClass: "inspect-title",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_vm._v("Plot #" + _vm._s(_vm.inspectTrx.tokenId))]), _vm._v(" "), _c('span', {
    staticClass: "inspect-size"
  }, [_vm._v(_vm._s(_vm.inspectTrx.x2 - _vm.inspectTrx.x1) + "x" + _vm._s(_vm.inspectTrx.y2 - _vm.inspectTrx.y1) + "px")])], 1), _vm._v(" "), _c('a', {
    staticClass: "inspect-url",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.url),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.inspectTrx.url))]), _vm._v(" "), (_vm.inspectTrx.profile) ? _c('div', {
    staticClass: "inspect-links"
  }, [(_vm.inspectTrx.profile.base_name) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://base.org/name/' + _vm.inspectTrx.profile.base_name.replace('.base.eth', ''),
      "target": "_blank",
      "title": "Base Name"
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 111 111",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M54.921 110.034C85.359 110.034 110.034 85.402 110.034 55.017C110.034 24.6319 85.359 0 54.921 0C26.0432 0 2.35281 22.1714 0 50.3923H72.8467V59.6416H3.9565e-07C2.35281 87.8625 26.0432 110.034 54.921 110.034Z",
      "fill": "#0052FF"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.website_url && _vm.inspectTrx.profile.website_url !== _vm.inspectTrx.url) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.profile.website_url),
      "target": "_blank",
      "title": "Website"
    }
  }, [_c('svg', {
    staticClass: "bi bi-link-45deg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.x_username) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://x.com/' + _vm.inspectTrx.profile.x_username,
      "target": "_blank",
      "title": "X / Twitter"
    }
  }, [_c('svg', {
    staticClass: "bi bi-twitter-x",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.tg_url) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": _vm.$safeUrl(_vm.inspectTrx.profile.tg_url),
      "target": "_blank",
      "title": "Telegram"
    }
  }, [_c('svg', {
    staticClass: "bi bi-telegram",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.287 5.906q-1.168.486-4.666 2.01-.567.225-.595.442c-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294q.39.01.868-.32 3.269-2.206 3.374-2.23c.05-.012.12-.026.166.016s.042.12.037.141c-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8 8 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629q.14.092.27.187c.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.4 1.4 0 0 0-.013-.315.34.34 0 0 0-.114-.217.53.53 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.token_ca) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://dexscreener.com/base/' + _vm.inspectTrx.profile.token_ca,
      "target": "_blank",
      "title": "Token Chart"
    }
  }, [_c('svg', {
    staticClass: "bi bi-graph-up",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M0 0h1v15h15v1H0zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.inspectTrx.profile.nft_ca) ? _c('a', {
    staticClass: "inspect-social",
    attrs: {
      "href": 'https://magiceden.us/collections/base/' + _vm.inspectTrx.profile.nft_ca,
      "target": "_blank",
      "title": "NFT Collection"
    }
  }, [_c('svg', {
    staticClass: "bi bi-images",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "16",
      "height": "16",
      "fill": "currentColor",
      "viewBox": "0 0 16 16"
    }
  }, [_c('path', {
    attrs: {
      "d": "M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-dark btn-sm inspect-view-btn",
    attrs: {
      "to": '/plot/' + _vm.inspectTrx.tokenId
    }
  }, [_vm._v("View Plot Details")])], 1)], 1)]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qlaW":
/***/ (function(module, exports) {

module.exports = [{"inputs":[{"internalType":"address","name":"initialOwner","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"EnforcedPause","type":"error"},{"inputs":[],"name":"ExpectedPause","type":"error"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"OwnableInvalidOwner","type":"error"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"OwnableUnauthorizedAccount","type":"error"},{"inputs":[],"name":"ReentrancyGuardReentrantCall","type":"error"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"numerator","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalDenominator","type":"uint256"}],"name":"AllocationUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"string","name":"reason","type":"string"}],"name":"ClaimFailed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"EmergencyWithdrawal","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldContract","type":"address"},{"indexed":true,"internalType":"address","name":"newContract","type":"address"}],"name":"NftContractUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"totalDenominator","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"timestamp","type":"uint256"}],"name":"RewardAllocated","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"wallet","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"RewardClaimed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"SecondaryOwnerUpdated","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"allocateReward","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"allocatedTokenIds","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"wallet","type":"address"},{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"}],"name":"claimAllocation","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256[]","name":"tokenIds","type":"uint256[]"},{"internalType":"address","name":"recipient","type":"address"}],"name":"claimAllocationAsOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"emergencyWithdraw","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"getAllocatedTokenIds","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getContractBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNftContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getTokenIdAllocation","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalDenominator","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getTotalUnclaimedBalance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"nftContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"pause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"secondaryOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_nftContract","type":"address"}],"name":"setNftContract","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_secondaryOwner","type":"address"}],"name":"setSecondaryOwner","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenAllocations","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalAllocated","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalClaimed","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalDenominator","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"unclaimedAllocations","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"unpause","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"numerator","type":"uint256"}],"name":"updateTokenIdAllocation","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}]

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_set__ = __webpack_require__("OVpc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__ = __webpack_require__("ZZvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__("SYh3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("L/hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__constants__ = __webpack_require__("oiih");









var getImageFromBlob = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(blob) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt('return', new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              var img = new Image();
              img.onload = function () {
                resolve(img);
              };
              img.onerror = function (e) {
                console.error("Error loading image from blob:", e);
                reject(e);
              };
              img.src = URL.createObjectURL(blob);
            }));

          case 1:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getImageFromBlob(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getScaledImageContext = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(width, height, uploadedBlob) {
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt('return', new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
              // Detached canvas: this runs on every resize/drag, so don't add it to the page.
              var newCanvas = document.createElement('canvas');
              newCanvas.width = width;
              newCanvas.height = height;
              var destCtx = newCanvas.getContext("2d");

              getImageFromBlob(uploadedBlob).then(function (origImg) {
                destCtx.imageSmoothingEnabled = true;
                destCtx.imageSmoothingQuality = 'high';
                destCtx.clearRect(0, 0, width, height);
                destCtx.drawImage(origImg, 0, 0, width, height);
                resolve(destCtx);
              }).catch(function (e) {
                console.error("Error getting image from blob:", e);
                reject(e);
              });
            }));

          case 1:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getScaledImageContext(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

// TODO deprecate this


var setImageSize = function () {
  var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3(self, width, height, x, y) {
    var uploadedImgCanvas, uploadedImgCtx, origImg, destCtx, d;
    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            log('setImageSize', width, height, x, y);

            // Re sample reference image
            uploadedImgCanvas = document.getElementById("uploadedImg");

            uploadedImgCanvas.style.display = 'block';
            uploadedImgCanvas.width = width;
            uploadedImgCanvas.height = height;
            uploadedImgCanvas.style.width = width + 'px';
            uploadedImgCanvas.style.height = height + 'px';
            uploadedImgCtx = uploadedImgCanvas.getContext("2d");

            uploadedImgCtx.imageSmoothingEnabled = true;
            uploadedImgCtx.imageSmoothingQuality = 'high';
            _context3.next = 12;
            return getImageFromBlob(window.uploadedBlob);

          case 12:
            origImg = _context3.sent;

            uploadedImgCtx.clearRect(0, 0, width, height);
            uploadedImgCtx.drawImage(origImg, 0, 0, width, height);

            // Set pixel data scaled
            _context3.next = 17;
            return getScaledImageContext(width, height, window.uploadedBlob);

          case 17:
            destCtx = _context3.sent;
            d = destCtx.getImageData(0, 0, width, height).data;

            __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].replaceTransparent(d);
            window.myImageData = d;

            window.img_width = width;
            window.img_height = height;

            if (x !== undefined && y !== undefined) {
              setImageOffset(x, y);
            }

            // Re validate image location
            self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);

          case 25:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function setImageSize(_x5, _x6, _x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/*global ethers*/
/*global ethereum*/
/*global qq*/
/*global interact*/
/*global pako*/
/*global _*/
var Buffer = __webpack_require__("63KW").Buffer;
window.Buffer = Buffer;





__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_loading_overlay___default.a);





var DEMO_MODE = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).DEMO_MODE || false;
var DEMO_ADDRESS = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).DEMO_ADDRESS || false;
var WEBHOOK_URL = 'https://ta2f7ylhwu46yoen7xk2pvueee0qtjjt.lambda-url.us-west-2.on.aws/';
var PUSH_SUB_URL = 'https://nnwj3qjluewoavvztzguep5yse0dgbet.lambda-url.us-west-2.on.aws/';
var TOKEN_PIXEL_PRICE = 1;
var ETH_PIXEL_PRICE = DEMO_ADDRESS ? 0.000085 : 0.000085; // 0.000085 // $1 USD at 5/29/2024
var BID_TO_ADDRESS = DEMO_ADDRESS ? '0xCF6ecdA3F26F2fbd242Ec7f7Aa59a3B627e912ab' : '0x5493dB14A2b6fd71B531fa1CFc752FdFaD734AcD'; // MBH
var TOKEN_IMAGE_URL = 'https://millionbithomepage.com/static/favicon-32x32.png';
var ETH_NETWORK = '1'; // '1' is the Ethereum main network ID.
var BASE_NETWORK = '8453'; // Base Mainnet
var BASE_CHAIN_ID = '0x2105'; // Base Mainnet
var BASE_RPC_URL = 'https://mainnet.base.org';
// For wallets that don't know Base yet (wallet_addEthereumChain).
var BASE_CHAIN_PARAMS = {
  chainId: BASE_CHAIN_ID,
  chainName: 'Base',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: [BASE_RPC_URL],
  blockExplorerUrls: ['https://basescan.org']
};
var ETH_GAS_PRICE = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).ETH_GAS_PRICE || '0.000000002';
var ETH_GAS_LIMIT = __webpack_require__.i({"NODE_ENV":"production","BASE_S3_BUCKET":"https://millionbithomepage.com/static/billboard/","BASE_S3_BUCKET_TRX":"https://millionbithomepage.com/trx/"}).ETH_GAS_LIMIT || 6000000; // max is around 8000000?
var PIXEL_PER_SQUARE = 16;
var MAX_IMAGE_SIZE = PIXEL_PER_SQUARE * 4;
var applicationServerPublicKey = 'BESOSUO9VPh2EnimIVXt9MjactiD21wbBivbfB4JZr5UWtVN8dQGUOg0uFzB9uWFdLPGfYFkCCDq3pv6XzNIGrQ';
var DID_PROMPT_NOTIFICATIONS = 'DID_PROMPT_NOTIFICATIONS';
var LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT = 'NOTIFICATION_SUB_ENDPOINT';
var LOCAL_STORAGE_KEY_REFERRAL = 'REF_CODE';
var LOCAL_STORAGE_KEY_DEMO_VID = 'DEMO_VID';
var BASENAME_L2_RESOLVER_ADDRESS = '0xC6d566A56A1aFf6508b41f6c90ff131615583BCD';

var UNISWAP_ROUTER_V3 = '0x2626664c2603336E57B271c5C0b26F421741e481';
var UNISWAP_QUOTER_V3 = '0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a'; //'0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a';
var UNISWAP_QUOTER_V2 = '0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24'; //'0x3d4e44Eb1374240CE5F1B871ab261CD16335B76a';
var WETH_ADDRESS = "0x4200000000000000000000000000000000000006"; // WETH on Ethereum mainnet
var FEE_TIER = Number(10000); // Uniswap V3 pool fee (3000 = 0.3%)

var DO_LOG = "production" !== 'production';
function log() {
  if (DO_LOG) {
    console.log.apply(console, arguments);
  }
}

function urlB64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function trackEvent(t) {
  try {
    if (window.umami) {
      window.umami.track(t);
    }
  } catch (e) {
    console.error('Failed to track event', e);
  }
}

function doCountdown() {
  var second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

  var countDownEndDate = new Date("10/10/2024");
  var countDown = countDownEndDate.getTime();
  window.countdownInterval = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDown - now;
    if (distance < 0) {
      distance = 0;
      clearInterval(window.countdownInterval);
    }

    document.getElementById("days").innerText = Math.floor(distance / day), document.getElementById("hours").innerText = Math.floor(distance % day / hour), document.getElementById("minutes").innerText = Math.floor(distance % hour / minute), document.getElementById("seconds").innerText = Math.floor(distance % minute / second);

    //do something later when date is reached
    if (distance < 0) {
      // document.getElementById("countdown").style.display = "none";
      clearInterval(window.countdownInterval);
    }
    //seconds
  }, 0);
}

function stringDataForEth(arr, url, bid, r, c) {
  var DATA_ENCODING_VERSION = 1;
  // for(var i in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //   for(var ii in [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16]) {
  //     is.push(""+i+","+ii+"#0000ff");
  //   }
  // }
  // log('window offset', window.img_offset_x, window.img_offset_y);
  // log('STRING DATA FOR PIXEL DATA', arr, r, c, typeof r, typeof c)

  if (typeof r === 'string') {
    r = parseInt(r, 10);
  }
  if (typeof c === 'string') {
    c = parseInt(c, 10);
  }

  var colors = [];
  for (var i in arr) {
    var p = arr[i];
    colors.push(p['hex']);
  }
  var xOffset = window.img_offset_x / 16 + c;
  var yOffset = window.img_offset_y / 16 + r;
  log('stringDataForEth', window.img_offset_x, window.img_offset_y, xOffset, yOffset, c, r);
  return "v" + DATA_ENCODING_VERSION + "|" + xOffset + "," + yOffset + "|" + colors.join(',') + "|" + bid + "|" + encodeURIComponent(url);
}

function getPriceForPosition(img_offset_x, img_offset_y, canvasWidth, canvasHeight, disallowExistingPixels) {
  var tokenCost = 0;
  // log('getPriceForPosition', img_offset_x, img_offset_y, canvasWidth, canvasHeight)
  window.segmentPrices = [];

  var coversExistingPixels = false;
  var pixelsPerSegment = 16 * 16;

  _.times(canvasHeight / 16, function (h) {
    var cols = [];
    _.times(canvasWidth / 16, function (w) {
      // Find if there is a link for this plot
      var x1 = img_offset_x + w * 16;
      var y1 = img_offset_y + h * 16;

      // log(`getPriceForPosition`, x1, y1, x1 + 16, y1 + 16);
      var linkDoc = _.find(window.linkMap, { 'c': x1 + ',' + y1 + ',' + (x1 + 16) + ',' + (y1 + 16) });
      if (linkDoc) {
        log('linkDoc', linkDoc);
        if (linkDoc.u) {
          coversExistingPixels = true;
        }
      }

      var sectionPriceInWei = pixelsPerSegment;
      tokenCost = tokenCost + sectionPriceInWei;

      cols.push(tokenCost);
    });
    window.segmentPrices.push(cols);
  });

  if (disallowExistingPixels && coversExistingPixels) {
    return false;
  }

  // log('window.segmentPrices', window.segmentPrices)
  return tokenCost;
}

function getHexFromRgb(r, g, b) {
  return ("0" + r.toString(16)).slice(-2) + ("0" + g.toString(16)).slice(-2) + ("0" + b.toString(16)).slice(-2);
}

function getPixelsData(myImageData, width, height) {
  log('getPixelsData', myImageData, width, height);
  var pixels_arr = [];
  var p = 0;
  for (var i in myImageData) {
    if (i % 4 === 0) {
      pixels_arr[p] = {
        "r": myImageData[i]
      };
    } else if (i % 4 === 1) {
      pixels_arr[p]["g"] = myImageData[i];
    } else if (i % 4 === 2) {
      pixels_arr[p]["b"] = myImageData[i];
    } else if (i % 4 === 3) {
      pixels_arr[p]["a"] = myImageData[i];
      // log(pixels_arr[p]["a"])
      pixels_arr[p]["hex"] = getHexFromRgb(pixels_arr[p]["r"], pixels_arr[p]["g"], pixels_arr[p]["b"]);
      // if(p % canvas.width == 0) {
      //   log(pixels_arr[p])
      // }
      p++;
    }
  }

  var rows = [];
  var ha = new Array(height / 16);
  var wa = new Array(width / 16);
  for (var hi = 0; hi < ha.length; hi++) {
    // for each vertical section
    var cols = [];
    for (var wi = 0; wi < wa.length; wi++) {
      // for each horizontal section
      cols.push([]);
    }
    rows.push(cols);
  }

  // rows is multidimension array to hold image data

  var _loop = function _loop(row) {
    // for each vertical section
    _.times(16, function (y) {
      var _loop2 = function _loop2(col) {
        // for each horizontal section
        _.times(16, function (x) {
          rows[row][col].push(pixels_arr.shift());
        });
      };

      for (var col = 0; col < wa.length; col++) {
        _loop2(col);
      }
    });
  };

  for (var row = 0; row < ha.length; row++) {
    _loop(row);
  }

  return rows;
}

function getScaledContext(origWidth, origHeight, width, height, imgd) {

  var newCanvas = document.createElement('canvas');
  newCanvas.width = width;
  newCanvas.height = height;
  newCanvas.style.visibility = 'hidden';

  document.body.appendChild(newCanvas);

  var destCtx = newCanvas.getContext("2d");

  var tmpCanvas = document.createElement('canvas');
  tmpCanvas.width = origWidth;
  tmpCanvas.height = origHeight;
  tmpCanvas.style.visibility = 'hidden';
  document.body.appendChild(tmpCanvas);

  tmpCanvas.getContext("2d").putImageData(imgd, 0, 0);

  destCtx.drawImage(tmpCanvas, 0, 0, width, height);

  return destCtx;
}

function fetchImage(url) {
  return fetch(url).then(function (response) {
    return response.blob();
  }).then(function (blob) {
    var fileName = url.substring(url.lastIndexOf('/') + 1);
    return new File([blob], fileName, { type: blob.type });
  });
}

function setImageOffset(x, y) {
  window.img_offset_x = x;
  window.img_offset_y = y;
}

function initUploader(self) {
  log('initUploader');
  setImageOffset(0, 0);

  if (window.manualUploader) {
    __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].clearDraggableImage();
    window.manualUploader.reset();
    delete window.manualUploader;
  }

  if (window.interactable) {
    window.interactable.unset();
    delete window.interactable;
  }

  if (self.loader) {
    self.loader.hide();
  }

  function resizeImageMax(canvas, img) {
    // Resize if too large
    var maxSize = MAX_IMAGE_SIZE;
    var width = canvas.width;
    var height = canvas.height;
    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else {
      if (height > maxSize) {
        width *= maxSize / height;
        height = maxSize;
      }
    }

    // Scale to PIXEL_PER_SQUARE 
    if (width % PIXEL_PER_SQUARE !== 0) {
      width = width - width % PIXEL_PER_SQUARE;
    }
    if (height % PIXEL_PER_SQUARE !== 0) {
      height = height - height % PIXEL_PER_SQUARE;
    }
    return { canvasWidth: width, canvasHeight: height };
  }

  window.uploadedImgData = null;

  window.manualUploader = new qq.FineUploader({
    element: document.getElementById('fine-uploader-manual-trigger'),
    template: 'qq-template-manual-trigger',
    callbacks: {
      onStatusChange: function onStatusChange(id, old, newStatus) {
        log("onStatusChange", arguments);
        if (newStatus === 'submitting') {
          log('submitting');
          self.loader = self.$loading.show({
            // Optional parameters
            // container: this.fullPage ? null : this.$refs.formContainer,
            // canCancel: true,
            // onCancel: this.onCancel,
          });
        } else if (newStatus === 'submitted') {
          log('submitted');
        } else if (newStatus === 'rejected') {
          this.reset();
          self.loader.hide();
          self.showAlert('The selected image is too large.');
        }
      }
      // onSubmitted: function(id) {
      //   log("onSubmitted", self)
      // },
      // onSubmit: function(id) {
      //   log("onSubmit", self)
      // },
      // onCancel: function(id) {
      //   log("CANCELED")
      // },
      // onProgress: function(id) {
      //   log("onProgress")
      // },
      // onValidate: function(id) {
      //   log("onValidate")
      // },
      // onError: function(id) {
      //   log("onError", arguments)
      // },
    },
    thumbnails: {
      // placeholders: {
      //     waitingPath: '/source/placeholders/waiting-generic.png',
      //     notAvailablePath: '/source/placeholders/not_available-generic.png'
      // },
      customResizer: function () {
        var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(resizeInfo) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  return _context6.abrupt('return', new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_promise___default.a(function () {
                    var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5(resolve, reject) {
                      var _this = this;

                      var canvas, _resizeImageMax, canvasWidth, canvasHeight, dragMoveListener;

                      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              dragMoveListener = function dragMoveListener(event) {
                                // document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
                                var target = event.target,

                                // keep the dragged position in the data-x/data-y attributes
                                x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
                                    y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

                                target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
                                target.setAttribute('data-x', x);
                                target.setAttribute('data-y', y);
                              };

                              log('customResizer');
                              log(resizeInfo);
                              window.uploadedBlob = resizeInfo.blob;
                              canvas = resizeInfo.sourceCanvas;


                              log("Uploaded image", canvas.width, canvas.height, canvas);
                              trackEvent('uploadedImage');
                              trackEvent('add_to_cart');
                              self.saveEvent('uploadedImage', {});

                              document.getElementById('million-bit-billboard').classList.add('tooltip-place');

                              _resizeImageMax = resizeImageMax(canvas), canvasWidth = _resizeImageMax.canvasWidth, canvasHeight = _resizeImageMax.canvasHeight;
                              _context5.next = 13;
                              return setImageSize(self, canvasWidth, canvasHeight, 0, 0);

                            case 13:

                              // Check if we have a spot we would like to place this
                              // console.log(`Checking if we have a spot we would like to place this image on`, self.uploadToXY);
                              if (self.uploadToXY && self.uploadToXY.x && self.uploadToXY.y) {
                                // console.log(`Placing image on spot`, self.uploadToXY);
                                self.moveImage(self.uploadToXY.x, self.uploadToXY.y, true);
                                self.uploadToXY = null;
                                self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
                              }

                              // target elements with the "draggable" class
                              window.interactable = interact('#uploadedImg').resizable({
                                origin: 'parent',
                                edges: {
                                  top: false,
                                  left: false,
                                  bottom: true,
                                  right: true
                                },
                                modifiers: [
                                // https://interactjs.io/docs/snapping/#snapsize
                                interact.modifiers.snapSize({
                                  targets: [interact.snappers.grid({ width: 16, height: 16 })]
                                }),
                                // https://interactjs.io/docs/snapping/#snap
                                // interact.modifiers.snap({
                                //   targets: [
                                //     interact.createSnapGrid({ x: 16, y: 16 })
                                //   ],
                                //   relativePoints: [ { x: 0, y: 0 } ]
                                // }),
                                interact.modifiers.restrictSize({
                                  min: { width: 16, height: 16 },
                                  max: { width: MAX_IMAGE_SIZE, height: MAX_IMAGE_SIZE }
                                })]
                              }).on('resizemove', function () {
                                var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(event) {
                                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                                    while (1) {
                                      switch (_context4.prev = _context4.next) {
                                        case 0:
                                          log('resizemove', event.rect.width, event.rect.height, event);
                                          _context4.next = 3;
                                          return setImageSize(self, event.rect.width, event.rect.height);

                                        case 3:
                                        case 'end':
                                          return _context4.stop();
                                      }
                                    }
                                  }, _callee4, _this);
                                }));

                                return function (_x13) {
                                  return _ref6.apply(this, arguments);
                                };
                              }()).draggable({
                                origin: 'parent',
                                inertia: false, // disable inertial throwing
                                // keep the element within the area of it's parent
                                // edges: { top: true, left: true },
                                modifiers: [interact.modifiers.snap({
                                  targets: [interact.createSnapGrid({ x: 16, y: 16 })],
                                  relativePoints: [{ x: 0, y: 0 }]
                                }), interact.modifiers.restrict({
                                  restriction: "parent",
                                  endOnly: false,
                                  elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
                                })],
                                autoScroll: true,
                                // call this function on every dragmove event
                                onmove: dragMoveListener,
                                // call this function on every dragend event
                                onend: function onend(event) {
                                  var parentPos = document.getElementById('million-bit-billboard').getBoundingClientRect();
                                  var childrenPos = document.getElementById('uploadedImg').getBoundingClientRect();

                                  setImageOffset(Math.floor(childrenPos.left - parentPos.left), Math.floor(childrenPos.top - parentPos.top));
                                  self.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
                                }
                              });

                              window.interactable.reflow({ name: 'drag', axis: 'xy' });

                              self.loader.hide();
                              self.canBuy = true;

                              resolve();

                            case 19:
                            case 'end':
                              return _context5.stop();
                          }
                        }
                      }, _callee5, this);
                    }));

                    return function (_x11, _x12) {
                      return _ref5.apply(this, arguments);
                    };
                  }()));

                case 1:
                case 'end':
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function customResizer(_x10) {
          return _ref4.apply(this, arguments);
        }

        return customResizer;
      }()
    },
    autoUpload: false,
    debug: DO_LOG,
    validation: {
      allowedExtensions: ["jpeg", "jpg", "png"],
      acceptFiles: "image/jpeg, image/png",
      stopOnFirstInvalidFile: true,
      sizeLimit: 50000 * 1000
    }
  });
}

function getEncodedEthDataValue(DATA_VALUE_UNENCODED) {
  return ethers.AbiCoder.defaultAbiCoder().encode([{ "name": "_value", "type": "string" }], [DATA_VALUE_UNENCODED]);
}

function pollForCompletion(txHash, callback) {
  var calledBack = false;

  // Normal ethereum blocks are approximately every 15 seconds.
  // Here we'll poll every 2 seconds.
  var checkInterval = setInterval(function () {

    var notYet = 'response has no error or result';

    ethereum.sendAsync({
      method: 'eth_getTransactionByHash',
      params: [txHash]
    }, function (err, response) {
      if (calledBack) return;
      if (err || response.error) {
        if (err.message.includes(notYet)) {
          return 'transaction is not yet mined';
        }
        callback(err || response.error);
      }
      // We have successfully verified the mined transaction.
      // Mind you, we should do this server side, with our own blockchain connection.
      // Client side we are trusting the user's connection to the blockchain.
      var transaction = response.result;
      clearInterval(checkInterval);
      calledBack = true;
      callback(null, transaction);
    });
  }, 2000);
}

var multiplyEth = function multiplyEth(eth, multiplier) {
  var multipliedWeiValue = ethers.parseUnits(eth) * BigInt(multiplier);
  return ethers.formatEther(multipliedWeiValue);
};
var divEth = function divEth(eth, divisor) {
  var dividedWeiValue = ethers.parseUnits(eth) / BigInt(divisor);
  return ethers.formatEther(dividedWeiValue);
};

// Providers whose accountsChanged/chainChanged we already listen to. Phantom
// re-announces itself on every eip6963:requestProvider.
var listenedProviders = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_weak_set___default.a();

var isUnknownChainError = function isUnknownChainError(e) {
  return !!e && (e.code === 4902 || e.data && e.data.originalError && e.data.originalError.code === 4902 || /unrecognized chain/i.test(e.message || ''));
};

var infuraProvider = new ethers.InfuraProvider("mainnet", "64e05046ef9d4b55866de25292aee3df");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    isGame: function isGame() {
      return this.$route.path === '/break' || this.$route.path === '/drop';
    },
    xPostSuccess: function xPostSuccess() {
      var tweetText = 'I just got my spot on the Million Bit Homepage! Go check it out and get yours @BitHomepage';
      var tweetUrl = this.shareUrl;
      if (this.$route.path == '/dob') {
        tweetText = 'I just got my spot on the DOB Pixel Gallery! Go check it out and get yours @doodle_on_base';
        tweetUrl = 'https://www.dob-nft.io/dob-millionpixelpage/';
      } else if (this.$route.path == '/zora') {
        tweetText = 'I just got my spot on the Million @zora Post! Go check it out and get yours @BitHomepage';
        tweetUrl = 'https://millionbithomepage.com/zora';
      }
      return 'https://x.com/intent/post?text=' + encodeURIComponent(tweetText) + '&url=' + encodeURIComponent(tweetUrl);
    },
    xPostInvite: function xPostInvite() {
      return 'https://x.com/intent/post?text=' + encodeURIComponent('Get your spot on the Million Bit Homepage to be a part of onchain history! @BitHomepage') + '&url=' + encodeURIComponent(this.shareUrl);
    },
    queryRefCode: function queryRefCode() {
      var ref = '';
      if (window.location && window.location.search) {
        var urlParams = new URLSearchParams(window.location.search);
        ref = urlParams.get('ref');
      }
      return localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL) || ref || '';
    },
    deepLinkMetamask: function deepLinkMetamask() {
      var refCode = this.queryRefCode;
      var host = window.location.host;
      return 'https://metamask.app.link/dapp/' + host + '/' + (refCode ? '?ref=' + refCode : '');
    },
    deepLinkCoinbase: function deepLinkCoinbase() {
      var refCode = this.queryRefCode;
      var host = window.location.host;
      return 'https://go.cb-w.com/dapp?cb_url=' + encodeURIComponent('https://' + host + '/' + (refCode ? '?ref=' + refCode : ''));
    },
    shareUrl: function shareUrl() {
      // URL with refCode if available
      var url = 'https://millionbithomepage.com/';
      if (this.refCode) {
        url += '?ref=' + this.refCode;
      }
      return url;
    },
    ethAmtFormatted: function ethAmtFormatted() {
      return parseFloat(this.ethAmt).toFixed(3);
    }
  },
  data: function data() {
    return {
      demoMode: DEMO_MODE,
      test_msg: '',
      logoMoji: '💠',
      title: 'Million Bit Homepage',
      tagline: 'Own a bit of onchain history!',
      variant: 'primary',
      variantNavButton: 'outline-light',
      isMobileOrTouch: false,
      touchTimer: null,
      alertMsg: '',
      alertSwapOpts: {},
      canBuy: false,
      buyLoading: false,
      canSend: false,
      ethPerPixel: ETH_PIXEL_PRICE,
      ethAmt: "0.000",
      tokenAmt: "0.000",
      tokenPerPixel: TOKEN_PIXEL_PRICE,
      ethTokenToggle: true, // TRUE is ETH
      canToggleEthToken: false, // Can toggle between ETH and token?
      canMint: true, // Enable for NFT minting
      formInputUrl: DEMO_ADDRESS ? 'https://x.com/BitHomepage' : '',
      toggleHomepageList: true,
      requireEthBalance: true,
      isSmartWallet: false,
      trxHashSuccess: '',
      watchedDemo: false,
      email: 'mailto:millionbithomepage@gmail.com',
      telegram: 'https://t.me/+_gBV-0hdCmQzYzgx',
      discord: 'https://discord.gg/WGJwK5jkrU',
      twitter: 'https://x.com/BitHomepage',
      tiktok: 'https://www.tiktok.com/@bithomepage',
      youtube: 'https://www.youtube.com/channel/UCQtsrxAC_JT91CtGtCIxmrg',
      warpcast: 'https://warpcast.com/wopr',
      drakula: 'https://drakula.app/user/million?invite=NfmzCk',
      zora: 'https://zora.co/@millionbit',
      refCode: '',
      whiteLabel: false,
      contractAddress: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA,
      nftAddress: __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_CA,
      symbol: 'BITPIX',
      swapLink: 'https://millionbithomepage.com/', // TODO
      isConnecting: false,
      provider: null,
      connectAccountAddress: '',
      connectAccountAddressTrunc: '',
      providers: [],
      tokenBalance: '',
      connectAccountChainId: '',
      connectAccountEnsName: '',
      connectAccountEnsNameTrunc: '',
      connectAccountEnsAvatar: '',
      connectAccountEnsWebsite: '',
      // Promo until April 1st
      showPromo: false,
      promoMsg: '',
      rewardsMsg: '', // '$6.6K Earned',
      isZora: false,
      pfpVidSrc: '' // set after page load so it doesn't compete with the billboard
    };
  },
  provide: function provide() {
    var _this2 = this;

    return {
      updateAppRoute: this.updateAppRoute,
      postToLambda: this.postToLambda,
      saveEvent: this.saveEvent,
      getProviderSigner: this.getProviderSigner,
      doUpload: this.doUpload,
      handleWalletError: this.handleWalletError,
      showAlert: this.showAlert,
      getGasLimitFromEstimate: this.getGasLimitFromEstimate,
      connectWallet: this.connectWallet,
      appData: function appData() {
        return {
          isMobileOrTouch: _this2.isMobileOrTouch,
          canBuy: _this2.canBuy,

          twitter: _this2.twitter,
          discord: _this2.discord,
          telegram: _this2.telegram,
          email: _this2.email,
          tiktok: _this2.tiktok,
          youtube: _this2.youtube,
          warpcast: _this2.warpcast,
          drakula: _this2.drakula,
          zora: _this2.zora,

          connectedAccount: {
            address: _this2.connectAccountAddress,
            addressTrunc: _this2.connectAccountAddressTrunc,
            name: _this2.connectAccountEnsName,
            avatar: _this2.connectAccountEnsAvatar,
            website: _this2.connectAccountEnsWebsite
          }
        };
      }
    };
  },

  methods: {
    showDemoVideo: function showDemoVideo() {
      __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].trackEvent('showDemoVideo');
      this.saveEvent('showDemoVideo', {});
      localStorage.setItem(LOCAL_STORAGE_KEY_DEMO_VID, 'true');
      this.watchedDemo = true;
      this.$router.push('demo');
    },

    updateAppRoute: function () {
      var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7(newValue, oldValue) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                log('updateAppRoute', newValue, oldValue);
                this.toggleHomepageList = false;
                if (newValue === '/') {
                  this.resetBuy();
                }

                // TODO cleanup with map

                if (!(newValue === '/tang')) {
                  _context7.next = 20;
                  break;
                }

                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TANG_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_TANG_CA;
                this.symbol = 'TANG'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context7.next = 10;
                return this.updatePixelPrice();

              case 10:
                _context7.next = 12;
                return this.updateTokenPixelPrice();

              case 12:
                _context7.next = 14;
                return this.checkCanPayWithToken();

              case 14:
                this.ethTokenToggle = false;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context7.next = 85;
                break;

              case 20:
                if (!(newValue === '/dob')) {
                  _context7.next = 38;
                  break;
                }

                this.whiteLabel = true;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.DOB.TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.DOB.NFT_CA;
                this.symbol = 'DOB'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context7.next = 28;
                return this.updatePixelPrice();

              case 28:
                _context7.next = 30;
                return this.updateTokenPixelPrice();

              case 30:
                _context7.next = 32;
                return this.checkCanPayWithToken();

              case 32:
                this.ethTokenToggle = false;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context7.next = 85;
                break;

              case 38:
                if (!(newValue === '/preme')) {
                  _context7.next = 56;
                  break;
                }

                this.whiteLabel = false;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.PREME.TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.PREME.NFT_CA;
                this.symbol = 'PBP'; // TODO fetch from contract
                this.tokenPerPixel = 1; // TODO fetch from contract
                _context7.next = 46;
                return this.updatePixelPrice();

              case 46:
                _context7.next = 48;
                return this.updateTokenPixelPrice();

              case 48:
                _context7.next = 50;
                return this.checkCanPayWithToken();

              case 50:
                this.ethTokenToggle = true;
                this.canToggleEthToken = false;
                this.showPromo = false;

                this.resetBuy();
                _context7.next = 85;
                break;

              case 56:
                if (!(newValue === '/zora')) {
                  _context7.next = 75;
                  break;
                }

                this.whiteLabel = false;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.ZORA.TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].SUBPAGES.ZORA.NFT_CA;
                this.symbol = 'MZP'; // TODO fetch from contract
                this.tokenPerPixel = 100; // TODO fetch from contract
                _context7.next = 64;
                return this.updatePixelPrice();

              case 64:
                _context7.next = 66;
                return this.updateTokenPixelPrice();

              case 66:
                _context7.next = 68;
                return this.checkCanPayWithToken();

              case 68:
                this.ethTokenToggle = false;
                this.canToggleEthToken = false;
                this.showPromo = false;
                this.isZora = true;

                this.resetBuy();
                _context7.next = 85;
                break;

              case 75:
                this.whiteLabel = false;
                this.contractAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA;
                this.nftAddress = __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_CA;
                this.symbol = 'BITPIX';
                this.tokenPerPixel = 1;
                _context7.next = 82;
                return this.updatePixelPrice();

              case 82:
                _context7.next = 84;
                return this.checkCanPayWithToken();

              case 84:
                this.ethTokenToggle = true;
                // this.canToggleEthToken = true;

              case 85:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateAppRoute(_x14, _x15) {
        return _ref7.apply(this, arguments);
      }

      return updateAppRoute;
    }(),
    setPixelsToBuy: function setPixelsToBuy(pixels) {
      this.ethAmt = multiplyEth(this.ethPerPixel.toString(), pixels).toString();
      this.tokenAmt = multiplyEth(this.tokenPerPixel.toString(), pixels).toString();
    },
    validateImageLocation: function validateImageLocation(img_offset_x, img_offset_y, img_width, img_height) {
      log('validateImageLocation', img_offset_x, img_offset_y, img_width, img_height);

      // Verify that the img_offset_x and img_offset_y are on the 16 x 16 grid
      if (img_offset_x % 16 !== 0 || img_offset_y % 16 !== 0) {
        // Calculate the difference between the current position and the nearest 16 x 16 grid
        var dx = img_offset_x - Math.floor(img_offset_x / 16) * 16;
        var dy = img_offset_y - Math.floor(img_offset_y / 16) * 16;

        // Snap the image to the nearest 16 x 16 grid
        var image = document.getElementById('uploadedImg');
        var x = (img_offset_x || 0) - dx;
        var y = (img_offset_y || 0) - dy;

        // Apply the transformation
        image.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

        // Update the position attributes
        image.setAttribute('data-x', x);
        image.setAttribute('data-y', y);
        img_offset_x = Math.floor(img_offset_x / 16) * 16;
        img_offset_y = Math.floor(img_offset_y / 16) * 16;
      }

      var p = getPriceForPosition(img_offset_x, img_offset_y, img_width, img_height, true);
      if (p) {
        this.setPixelsToBuy(p);
        document.getElementById('million-bit-billboard').classList.remove('tooltip-place');
        this.canSend = true;
        return true;
      } else {
        // Cannot buy this location
        document.getElementById('million-bit-billboard').classList.add('tooltip-place');
        this.canSend = false;
        return false;
      }
    },
    navigateTo: function navigateTo(route) {
      this.$bvModal.hide('modal-intro');
      if (route === '/') {
        this.toggleHomepageList = true;
      } else {
        this.toggleHomepageList = false;
      }
      this.$router.push(route);
    },
    doToggleEthToken: function doToggleEthToken(isEth) {
      if (!isEth) {
        this.ethTokenToggle = false;
      } else {
        this.ethTokenToggle = true;
      }
    },
    doUpload: function doUpload(x, y) {
      if (this.canBuy) {
        this.cancelBuy();
        return;
      }
      this.uploadToXY = { x: x, y: y };
      trackEvent('doUpload:file');
      document.querySelector('input[name="qqfile"]').click();
    },
    doUploadAvatar: function () {
      var _ref8 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8(event) {
        var img;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                trackEvent('doUpload:avatar');
                _context8.next = 3;
                return fetchImage(this.connectAccountEnsAvatar);

              case 3:
                img = _context8.sent;

                window.manualUploader.addFiles(img);

              case 5:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function doUploadAvatar(_x16) {
        return _ref8.apply(this, arguments);
      }

      return doUploadAvatar;
    }(),
    connectWallet: function () {
      var _ref9 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                trackEvent('connectWallet');
                log('connectWallet');
                this.$bvModal.show('modal-connect');
                this.loadProviders();
                try {
                  window.dispatchEvent(new Event("eip6963:requestProvider"));
                } catch (error) {
                  log('Error requesting provider', error);
                }

              case 5:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function connectWallet() {
        return _ref9.apply(this, arguments);
      }

      return connectWallet;
    }(),
    createWallet: function () {
      var _ref10 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
        var coinbaseWalletSDK, coinbaseWalletProvider, _ref11, _ref12, address;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                trackEvent('createWallet');
                log('create Wallet');
                this.isConnecting = true;

                _context10.prev = 3;
                coinbaseWalletSDK = new CoinbaseWalletSDK({
                  appName: 'Million Bit Homepage',
                  appLogoUrl: 'https://millionbithomepage.com/static/mbh.png',
                  appChainIds: [8453]
                });
                _context10.next = 7;
                return coinbaseWalletSDK.makeWeb3Provider();

              case 7:
                coinbaseWalletProvider = _context10.sent;

                this.provider = coinbaseWalletProvider;
                log('coinbaseWalletProvider', coinbaseWalletProvider);
                _context10.next = 12;
                return coinbaseWalletProvider.request({
                  method: 'eth_requestAccounts'
                });

              case 12:
                _ref11 = _context10.sent;
                _ref12 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref11, 1);
                address = _ref12[0];

                log('created Wallet', address, coinbaseWalletProvider);
                _context10.next = 18;
                return this.setConnectedAccount(address);

              case 18:
                // await this.ensureBaseChain(this.provider);

                // const capabilities = await coinbaseWalletProvider.request({
                //   method: 'wallet_getCapabilities',
                //   // params:[address],
                // });
                // log('capabilities', capabilities);

                this.requireEthBalance = false; // Magic spend // https://www.smartwallet.dev/guides/magic-spend
                this.isSmartWallet = true;
                trackEvent('createdWallet');
                this.isConnecting = false;
                _context10.next = 28;
                break;

              case 24:
                _context10.prev = 24;
                _context10.t0 = _context10['catch'](3);

                this.isConnecting = false;
                this.handleError(_context10.t0);

              case 28:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 24]]);
      }));

      function createWallet() {
        return _ref10.apply(this, arguments);
      }

      return createWallet;
    }(),
    handleError: function handleError(error) {
      console.error(error);
      this.showAlert('An error occurred. Please try again.');
    },
    getBaseName: function () {
      var _ref13 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee11(address, baseProvider) {
        var addressReverseNode, contract, basename;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                addressReverseNode = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].convertReverseNodeToBytes(address, 8453); // 8453 is base chain id

                contract = new ethers.Contract(BASENAME_L2_RESOLVER_ADDRESS, __WEBPACK_IMPORTED_MODULE_13__constants__["a" /* default */].L2ResolverAbi, baseProvider);
                _context11.next = 5;
                return contract.name(addressReverseNode);

              case 5:
                basename = _context11.sent;
                return _context11.abrupt('return', basename);

              case 9:
                _context11.prev = 9;
                _context11.t0 = _context11['catch'](0);

                console.error('Error getting basename', _context11.t0);

              case 12:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 9]]);
      }));

      function getBaseName(_x17, _x18) {
        return _ref13.apply(this, arguments);
      }

      return getBaseName;
    }(),
    getEnsName: function () {
      var _ref14 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee12(address) {
        var ensName;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return infuraProvider.lookupAddress(address);

              case 2:
                ensName = _context12.sent;
                return _context12.abrupt('return', ensName);

              case 4:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getEnsName(_x19) {
        return _ref14.apply(this, arguments);
      }

      return getEnsName;
    }(),
    getEnsAvatar: function () {
      var _ref15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee13(ensName) {
        var avatar;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return infuraProvider.getAvatar(ensName);

              case 2:
                avatar = _context13.sent;

                log('Avatar for ' + ensName + ' URL: ' + avatar);
                return _context13.abrupt('return', avatar);

              case 5:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getEnsAvatar(_x20) {
        return _ref15.apply(this, arguments);
      }

      return getEnsAvatar;
    }(),
    getEnsWebsite: function () {
      var _ref16 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee14(ensName) {
        var resolver, website;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return infuraProvider.getResolver(ensName);

              case 2:
                resolver = _context14.sent;

                if (!resolver) {
                  _context14.next = 8;
                  break;
                }

                _context14.next = 6;
                return resolver.getText("url");

              case 6:
                website = _context14.sent;
                return _context14.abrupt('return', website);

              case 8:
                return _context14.abrupt('return', null);

              case 9:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function getEnsWebsite(_x21) {
        return _ref16.apply(this, arguments);
      }

      return getEnsWebsite;
    }(),
    // resolveEnsAvatar: async function(ensName, provider) {
    //   const resolver = await ethers.EnsResolver.fromName(provider, ensName);
    //   console.log('resolver', resolver)
    //   if (resolver) {
    //       // Resolve the avatar
    //       const avatarUrl = await resolver.getAvatar();
    //       if (avatarUrl) {
    //           console.log(`Avatar URL: ${avatarUrl}`);
    //       } else {
    //           console.log("No avatar found for this ENS name.");
    //       }
    //   } else {
    //       console.log("ENS name not found.");
    //   }
    // },
    setConnectedAccount: function () {
      var _ref17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee15(account) {
        var _ref18, provider, signer, baseName, ensAvatar, ensWebsite, ensName, _ensAvatar, resolver, website;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                log('setConnectedAccount', account);
                if (account && this.connectAccountAddress && account.toLowerCase() !== this.connectAccountAddress.toLowerCase()) {
                  // A different account: drop the previous one's signer and profile.
                  this.resetProviderSigner();
                  this.connectAccountEnsName = '';
                  this.connectAccountEnsNameTrunc = '';
                  this.connectAccountEnsAvatar = '';
                  this.connectAccountEnsWebsite = '';
                }

                if (!account) {
                  _context15.next = 57;
                  break;
                }

                // Hide modal
                this.$bvModal.hide('modal-connect');
                this.connectAccountAddress = account;
                this.connectAccountAddressTrunc = account.substring(0, 6) + '…' + account.substring(account.length - 4);

                if (this.$refs.routerViewRef) {
                  this.$refs.routerViewRef.$emit('accountConnected', { message: 'Hello from parent' });
                }

                _context15.next = 9;
                return this.ensureBaseChain(this.provider);

              case 9:
                _context15.next = 11;
                return this.updatePixelPrice();

              case 11:
                _context15.next = 13;
                return this.checkCanPayWithToken();

              case 13:
                _context15.next = 15;
                return this.getProviderSigner();

              case 15:
                _ref18 = _context15.sent;
                provider = _ref18.provider;
                signer = _ref18.signer;
                _context15.next = 20;
                return this.getBaseName(account, signer);

              case 20:
                baseName = _context15.sent;

                if (!baseName) {
                  _context15.next = 33;
                  break;
                }

                this.setEnsName(baseName, 'baseName');
                _context15.next = 25;
                return this.getEnsAvatar(this.connectAccountEnsName);

              case 25:
                ensAvatar = _context15.sent;

                this.connectAccountEnsAvatar = ensAvatar || '';
                _context15.next = 29;
                return this.getEnsWebsite(this.connectAccountEnsName);

              case 29:
                ensWebsite = _context15.sent;

                if (ensWebsite) {
                  this.connectAccountEnsWebsite = ensWebsite;
                  this.formInputUrl = ensWebsite;
                } else {
                  log('No website found for address ' + this.connectAccountEnsName);
                  this.connectAccountEnsWebsite = '';
                }
                _context15.next = 54;
                break;

              case 33:
                log('No base name found for address ' + this.connectAccountAddress);
                _context15.next = 36;
                return this.getEnsName(this.connectAccountAddress);

              case 36:
                ensName = _context15.sent;

                if (!ensName) {
                  _context15.next = 54;
                  break;
                }

                this.setEnsName(ensName, 'ensName');
                _context15.next = 41;
                return infuraProvider.getAvatar(this.connectAccountEnsName);

              case 41:
                _ensAvatar = _context15.sent;

                this.connectAccountEnsAvatar = _ensAvatar;
                _context15.next = 45;
                return infuraProvider.getResolver(ensName);

              case 45:
                resolver = _context15.sent;

                if (!resolver) {
                  _context15.next = 53;
                  break;
                }

                _context15.next = 49;
                return resolver.getText("url");

              case 49:
                website = _context15.sent;

                if (website) {
                  log('The website for this.connectAccountEnsName ' + this.connectAccountEnsName + ' is ' + website);
                  this.connectAccountEnsWebsite = website;
                  this.formInputUrl = website;
                } else {
                  log('No website found for address ' + this.connectAccountEnsName);
                  this.connectAccountEnsWebsite = '';
                }
                _context15.next = 54;
                break;

              case 53:
                this.connectAccountEnsWebsite = '';

              case 54:
                this.saveEvent('connectedAccount', {});
                _context15.next = 65;
                break;

              case 57:
                this.connectAccountAddress = '';
                this.connectAccountAddressTrunc = '';
                this.connectAccountEnsName = '';
                this.connectAccountEnsNameTrunc = '';
                this.connectAccountEnsAvatar = '';
                this.connectAccountEnsWebsite = '';
                this.browserProvider = null;
                this.provider = null;

              case 65:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setConnectedAccount(_x22) {
        return _ref17.apply(this, arguments);
      }

      return setConnectedAccount;
    }(),
    setEnsName: function setEnsName(ensName, source) {
      this.connectAccountEnsName = ensName;
      if (this.connectAccountEnsName) {
        this.connectAccountEnsNameTrunc = this.connectAccountEnsName.length > 20 ? this.connectAccountEnsName.substring(0, 20) + '…' : this.connectAccountEnsName;
      } else {
        this.connectAccountEnsNameTrunc = '';
      }
      __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].trackEvent(source + ':' + ensName);
      log(source, ensName);
    },
    doConnect: function () {
      var _ref19 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee16(provider) {
        var accounts;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                // console.log(provider);
                log('do connect', provider);
                this.isConnecting = true;
                this.isSmartWallet = false;
                this.provider = provider.provider;
                _context16.prev = 4;
                _context16.next = 7;
                return this.provider.request({ method: "eth_requestAccounts" });

              case 7:
                accounts = _context16.sent;

                this.setConnectedAccount(accounts[0]);
                // this.ensureBaseChain(this.provider);
                this.isConnecting = false;
                _context16.next = 16;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16['catch'](4);

                console.error("Failed to connect to provider:", _context16.t0);
                this.isConnecting = false;

              case 16:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[4, 12]]);
      }));

      function doConnect(_x23) {
        return _ref19.apply(this, arguments);
      }

      return doConnect;
    }(),
    doDisconnect: function () {
      var _ref20 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee17() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.provider) {
                  _context17.next = 4;
                  break;
                }

                _context17.next = 3;
                return this.setConnectedAccount(null);

              case 3:
                return _context17.abrupt('return');

              case 4:
                _context17.prev = 4;
                _context17.next = 7;
                return this.provider.request({ method: "wallet_revokePermissions", "params": [{
                    "eth_accounts": {}
                  }] });

              case 7:
                _context17.next = 12;
                break;

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17['catch'](4);

                try {
                  this.provider.close();
                } catch (e) {
                  console.log('Couldnt close wallet');
                }

              case 12:
                // this.provider = null;
                // this.getWalletPermissions(this.provider);
                log('Disconnect provider', this.provider);

                if (!this.provider.disconnect) {
                  _context17.next = 16;
                  break;
                }

                _context17.next = 16;
                return this.provider.disconnect();

              case 16:
                _context17.next = 18;
                return this.setConnectedAccount(null);

              case 18:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[4, 9]]);
      }));

      function doDisconnect() {
        return _ref20.apply(this, arguments);
      }

      return doDisconnect;
    }(),
    doCopyToClipboard: function doCopyToClipboard(text) {
      var _this3 = this;

      navigator.clipboard.writeText(text).then(function () {
        _this3.showAlert('Copied to clipboard!');
      }).catch(function (err) {
        console.error('Failed to copy text: ', err);
      });
      // var dummy = document.createElement("textarea");
      // document.body.appendChild(dummy);
      // dummy.value = text;
      // dummy.select();
      // document.execCommand("copy");
      // document.body.removeChild(dummy);
    },
    getWalletPermissions: function () {
      var _ref21 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee18(provider, accounts) {
        var permissions, eth_accounts;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(accounts && accounts.length > 0)) {
                  _context18.next = 4;
                  break;
                }

                this.provider = provider;
                this.setConnectedAccount(accounts[0]);
                // this.ensureBaseChain(provider);
                return _context18.abrupt('return');

              case 4:
                if (!(provider.isCoinbaseBrowser || provider.isCoinbaseWallet)) {
                  _context18.next = 6;
                  break;
                }

                return _context18.abrupt('return');

              case 6:
                _context18.next = 8;
                return provider.request({ method: "wallet_getPermissions" });

              case 8:
                permissions = _context18.sent;

                log('getWalletPermissions', permissions);
                accounts = permissions.find(function (p) {
                  return p.parentCapability === "eth_accounts";
                });
                log('accounts', accounts);
                if (!accounts || !accounts.caveats) {
                  // log('Disconnect provider', provider);
                  // if (provider.disconnect) {
                  //   provider.disconnect();
                  // }
                  // this.setConnectedAccount(null);
                } else {
                  eth_accounts = accounts.caveats.find(function (c) {
                    return c.type === "restrictReturnedAccounts";
                  });

                  if (eth_accounts) {
                    log('eth accounts', eth_accounts);
                    this.provider = provider;
                    this.setConnectedAccount(eth_accounts.value[0]);
                  } else {
                    this.setConnectedAccount(null);
                  }
                }

              case 13:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getWalletPermissions(_x24, _x25) {
        return _ref21.apply(this, arguments);
      }

      return getWalletPermissions;
    }(),
    parseChainId: function parseChainId(chainId) {
      if (typeof chainId === 'string') {
        if (chainId.startsWith('0x')) {
          return parseInt(chainId, 16).toString();
        } else {
          return chainId;
        }
      } else if (typeof chainId === 'number') {
        return chainId.toString();
      }
    },
    isBaseChain: function isBaseChain(chainId) {
      log('isBaseChain', chainId, typeof chainId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(chainId), BASE_CHAIN_ID, typeof BASE_CHAIN_ID === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(BASE_CHAIN_ID), this.parseChainId(chainId), this.parseChainId(BASE_CHAIN_ID));
      return this.parseChainId(chainId) === this.parseChainId(BASE_CHAIN_ID);
    },
    switchToBaseChain: function switchToBaseChain(event) {
      this.ensureBaseChain(this.provider);
    },
    ensureBaseChain: function () {
      var _ref22 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee19(provider) {
        var chainId;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getEthChainId(provider);

              case 2:
                chainId = _context19.sent;

                this.connectAccountChainId = chainId;

                if (this.isBaseChain(chainId)) {
                  _context19.next = 22;
                  break;
                }

                log('Switching from chain ' + chainId + ' to base ' + BASE_CHAIN_ID);
                _context19.prev = 6;
                _context19.next = 9;
                return provider.request({
                  "method": "wallet_switchEthereumChain",
                  "params": [{ "chainId": BASE_CHAIN_ID.toString() }]
                });

              case 9:
                _context19.next = 18;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19['catch'](6);

                if (isUnknownChainError(_context19.t0)) {
                  _context19.next = 15;
                  break;
                }

                throw _context19.t0;

              case 15:
                log('Wallet does not know Base yet, adding it');
                _context19.next = 18;
                return provider.request({
                  "method": "wallet_addEthereumChain",
                  "params": [BASE_CHAIN_PARAMS]
                });

              case 18:
                _context19.next = 20;
                return this.getEthChainId(provider);

              case 20:
                this.connectAccountChainId = _context19.sent;

                this.resetProviderSigner();

              case 22:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[6, 11]]);
      }));

      function ensureBaseChain(_x26) {
        return _ref22.apply(this, arguments);
      }

      return ensureBaseChain;
    }(),
    // Resolves with the mined receipt, or null if none shows up in time.
    // Some wallets don't answer eth_getTransactionReceipt, so a public Base RPC
    // is asked as well.
    waitForReceipt: function () {
      var _ref23 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee21(txHash) {
        var _this4 = this;

        var timeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 120000;

        var askWallet, askBase, deadline, _arr, _i, ask, receipt;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                askWallet = function askWallet() {
                  return _this4.provider.request({ method: 'eth_getTransactionReceipt', params: [txHash] });
                };

                askBase = function () {
                  var _ref24 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee20() {
                    var res;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
                      while (1) {
                        switch (_context20.prev = _context20.next) {
                          case 0:
                            _context20.next = 2;
                            return fetch(BASE_RPC_URL, {
                              method: 'POST',
                              headers: { 'Content-Type': 'application/json' },
                              body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({ jsonrpc: '2.0', id: 1, method: 'eth_getTransactionReceipt', params: [txHash] })
                            });

                          case 2:
                            res = _context20.sent;
                            _context20.next = 5;
                            return res.json();

                          case 5:
                            return _context20.abrupt('return', _context20.sent.result);

                          case 6:
                          case 'end':
                            return _context20.stop();
                        }
                      }
                    }, _callee20, _this4);
                  }));

                  return function askBase() {
                    return _ref24.apply(this, arguments);
                  };
                }();

                deadline = Date.now() + timeoutMs;

              case 3:
                if (!(Date.now() < deadline)) {
                  _context21.next = 26;
                  break;
                }

                _arr = [askWallet, askBase];
                _i = 0;

              case 6:
                if (!(_i < _arr.length)) {
                  _context21.next = 22;
                  break;
                }

                ask = _arr[_i];
                _context21.prev = 8;
                _context21.next = 11;
                return ask();

              case 11:
                receipt = _context21.sent;

                if (!receipt) {
                  _context21.next = 14;
                  break;
                }

                return _context21.abrupt('return', receipt);

              case 14:
                _context21.next = 19;
                break;

              case 16:
                _context21.prev = 16;
                _context21.t0 = _context21['catch'](8);

                log('eth_getTransactionReceipt error', _context21.t0);

              case 19:
                _i++;
                _context21.next = 6;
                break;

              case 22:
                _context21.next = 24;
                return __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].wait(2000);

              case 24:
                _context21.next = 3;
                break;

              case 26:
                return _context21.abrupt('return', null);

              case 27:
              case 'end':
                return _context21.stop();
            }
          }
        }, _callee21, this, [[8, 16]]);
      }));

      function waitForReceipt(_x27) {
        return _ref23.apply(this, arguments);
      }

      return waitForReceipt;
    }(),
    // callback(err, receipt): err only when the transaction was mined and
    // reverted. If no receipt arrives in time the transaction is treated as
    // still processing (callback(null, null)), as before.
    pollForCompletion: function () {
      var _ref25 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee22(txHash, callback) {
        var receipt;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                this.trxHashSuccess = txHash;
                _context22.next = 3;
                return this.waitForReceipt(txHash);

              case 3:
                receipt = _context22.sent;

                if (!(receipt && receipt.status !== undefined && parseInt(receipt.status, 16) === 0)) {
                  _context22.next = 7;
                  break;
                }

                callback(new Error('Transaction reverted'), receipt);
                return _context22.abrupt('return');

              case 7:
                callback(null, receipt);

              case 8:
              case 'end':
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function pollForCompletion(_x29, _x30) {
        return _ref25.apply(this, arguments);
      }

      return pollForCompletion;
    }(),
    getEthChainId: function () {
      var _ref26 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee23(provider) {
        var chainId;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return provider.request({ method: "eth_chainId", "params": [] });

              case 2:
                chainId = _context23.sent;
                return _context23.abrupt('return', chainId);

              case 4:
              case 'end':
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getEthChainId(_x31) {
        return _ref26.apply(this, arguments);
      }

      return getEthChainId;
    }(),
    watchToken: function () {
      var _ref27 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee24() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.provider.request({
                  "method": "wallet_watchAsset",
                  "params": {
                    "type": "ERC20",
                    "options": {
                      "address": __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA,
                      "symbol": this.symbol,
                      "decimals": 18,
                      "image": TOKEN_IMAGE_URL
                    }
                  }
                });

              case 2:
              case 'end':
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function watchToken() {
        return _ref27.apply(this, arguments);
      }

      return watchToken;
    }(),
    getTokenBalance: function () {
      var _ref28 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee25(p) {
        var provider, signer, contract, balance;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                provider = new ethers.BrowserProvider(p);
                _context25.next = 3;
                return provider.getSigner();

              case 3:
                signer = _context25.sent;
                contract = new ethers.Contract(this.contractAddress, ["function balanceOf(address) view returns (uint256)"], signer);
                _context25.next = 7;
                return contract.balanceOf(this.connectAccountAddress);

              case 7:
                balance = _context25.sent;

                log('token balance', balance.toString());
                this.tokenBalance = balance.toString();
                return _context25.abrupt('return', balance);

              case 11:
              case 'end':
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function getTokenBalance(_x32) {
        return _ref28.apply(this, arguments);
      }

      return getTokenBalance;
    }(),
    cancelBuy: function cancelBuy(event) {
      this.resetBuy();
    },
    resetBuy: function resetBuy() {
      this.buyLoading = false;
      this.canBuy = false;
      initUploader(this);
    },
    getPixelPrice: function () {
      var _ref29 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee26(x1, y1, x2, y2) {
        var _ref30, provider, contract, price;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                log('Getting pixel price');
                _context26.next = 3;
                return this.getProviderSigner();

              case 3:
                _ref30 = _context26.sent;
                provider = _ref30.provider;
                contract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, provider);
                _context26.next = 8;
                return contract.calculateCurrentPrice(x1, y1, x2, y2);

              case 8:
                price = _context26.sent;

                log('Pixel price', price, typeof price === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(price));
                return _context26.abrupt('return', price);

              case 11:
              case 'end':
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function getPixelPrice(_x33, _x34, _x35, _x36) {
        return _ref29.apply(this, arguments);
      }

      return getPixelPrice;
    }(),
    getTokenPrice: function () {
      var _ref31 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee27() {
        var _ref32, provider, contract, price;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                log('Getting pixel price');
                _context27.next = 3;
                return this.getProviderSigner();

              case 3:
                _ref32 = _context27.sent;
                provider = _ref32.provider;
                contract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, provider);
                _context27.next = 8;
                return contract.tokenPrice();

              case 8:
                price = _context27.sent;

                console.log(price);
                log('Token Pixel price', price, typeof price === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(price));
                return _context27.abrupt('return', price);

              case 12:
              case 'end':
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getTokenPrice() {
        return _ref31.apply(this, arguments);
      }

      return getTokenPrice;
    }(),
    updatePixelPrice: function () {
      var _ref33 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee28() {
        var blockPrice;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!this.canMint) {
                  _context28.next = 8;
                  break;
                }

                if (this.connectAccountAddress) {
                  _context28.next = 4;
                  break;
                }

                log('Cant get pixel price until wallet is connected');
                return _context28.abrupt('return', 0);

              case 4:
                _context28.next = 6;
                return this.getPixelPrice(0, 0, 16, 16);

              case 6:
                blockPrice = _context28.sent;

                this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16 * 16));

              case 8:
              case 'end':
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function updatePixelPrice() {
        return _ref33.apply(this, arguments);
      }

      return updatePixelPrice;
    }(),
    updateTokenPixelPrice: function () {
      var _ref34 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee29() {
        var blockPrice;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                if (!this.canMint) {
                  _context29.next = 9;
                  break;
                }

                if (this.connectAccountAddress) {
                  _context29.next = 5;
                  break;
                }

                log('Cant get token pixel price until wallet is connected');
                this.$refs.routerViewRef.$on('accountConnected', this.updateTokenPixelPrice);
                return _context29.abrupt('return', 0);

              case 5:
                _context29.next = 7;
                return this.getTokenPrice();

              case 7:
                blockPrice = _context29.sent;

                // this.ethPerPixel = ethers.formatEther(blockPrice / BigInt(16*16));
                this.tokenPerPixel = blockPrice;

              case 9:
              case 'end':
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function updateTokenPixelPrice() {
        return _ref34.apply(this, arguments);
      }

      return updateTokenPixelPrice;
    }(),
    doBuy: function () {
      var _ref35 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee30(event) {
        var isLocationValid, account, amountToSend;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                trackEvent('doBuy');
                trackEvent('begin_checkout');
                this.saveEvent('doBuy', {});

                if (this.connectAccountAddress) {
                  _context30.next = 6;
                  break;
                }

                this.showAlert('Please connect your wallet first.');
                return _context30.abrupt('return');

              case 6:
                if (this.isBaseChain(this.connectAccountChainId)) {
                  _context30.next = 9;
                  break;
                }

                this.showAlert('Please switch to base network first.');
                return _context30.abrupt('return');

              case 9:

                this.buyLoading = true;

                // Check the image location is still available since the page loaded

                if (true) {
                  _context30.next = 19;
                  break;
                }

                if (!this.$refs.routerViewRef) {
                  _context30.next = 14;
                  break;
                }

                _context30.next = 14;
                return this.$refs.routerViewRef.fetchData(true);

              case 14:

                // Check for latest image and link data before sending to prevent overlap
                isLocationValid = this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);

                if (isLocationValid) {
                  _context30.next = 19;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Please review your image placement.');
                return _context30.abrupt('return');

              case 19:
                _context30.prev = 19;
                _context30.next = 22;
                return this.updatePixelPrice();

              case 22:
                _context30.next = 27;
                break;

              case 24:
                _context30.prev = 24;
                _context30.t0 = _context30['catch'](19);

                console.log('Error updating pixel price', _context30.t0);

              case 27:

                // Load pixel data
                window.pixels_data = getPixelsData(window.myImageData, window.img_width, window.img_height);
                log(window.pixels_data);
                log('pixel data done....');

                account = this.connectAccountAddress;
                amountToSend = this.ethTokenToggle ? this.ethAmt : this.tokenAmt;
                _context30.prev = 32;
                _context30.next = 35;
                return this.sendEtherFrom(account, amountToSend, this.ethTokenToggle, this.onBuySent);

              case 35:
                _context30.next = 43;
                break;

              case 37:
                _context30.prev = 37;
                _context30.t1 = _context30['catch'](32);

                // Anything the senders didn't handle themselves: never leave MINT spinning.
                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context30.t1);
                this.handleWalletError(_context30.t1);

              case 43:
              case 'end':
                return _context30.stop();
            }
          }
        }, _callee30, this, [[19, 24], [32, 37]]);
      }));

      function doBuy(_x37) {
        return _ref35.apply(this, arguments);
      }

      return doBuy;
    }(),
    // Called once the mint/send transaction is mined (or still pending after
    // the wait); err means it reverted.
    onBuySent: function () {
      var _ref36 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee31(err, transaction) {
        var refCode;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (!err) {
                  _context31.next = 7;
                  break;
                }

                this.buyLoading = false;
                trackEvent('trxFailed');
                trackEvent('trxReverted');
                this.saveEvent('trxReverted', { hash: this.trxHashSuccess });
                this.showAlert('The transaction failed on chain and nothing was minted. Please try again.');
                return _context31.abrupt('return');

              case 7:
                this.buyLoading = false;
                trackEvent('purchase');
                trackEvent('trxSuccess');

                // Show modal
                _context31.next = 12;
                return this.getRefCode();

              case 12:
                this.$bvModal.show('modal-success');
                // this.showAlert('Your transaction is being processed.');

                try {
                  fetch(WEBHOOK_URL + '?trigger=true', {
                    method: 'GET'
                  }).then(function (response) {
                    if (!response.ok) {
                      // throw new Error('Network response was not ok ' + response.statusText);
                      console.error('Network response was not ok ' + response.statusText);
                    }
                    return response.json(); // Assuming the response is JSON
                  }).then(function (data) {
                    console.log('Data received:', data);
                  }).catch(function (error) {
                    console.error('Fetch error:', error);
                  });
                  __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].confetti(10000); // PARTY!

                  // Send referral data
                  log(transaction);
                  refCode = localStorage.getItem(LOCAL_STORAGE_KEY_REFERRAL);

                  this.saveEvent('purchase', {
                    code: refCode,
                    transaction: transaction
                  });
                  // if (false && refCode) {
                  //   this.postToLambda('trxSuccess', {
                  //     code: refCode,
                  //     from: account,
                  //     transaction
                  //   });
                  // }
                } catch (e) {
                  console.error('Fetch error:', e);
                }

              case 14:
              case 'end':
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function onBuySent(_x38, _x39) {
        return _ref36.apply(this, arguments);
      }

      return onBuySent;
    }(),
    getEventUserEnv: function getEventUserEnv() {
      var userEnv = {
        ensName: this.connectAccountEnsName,
        address: this.connectAccountAddress,
        chainId: this.connectAccountChainId,
        agent: navigator.userAgent,
        isMobileOrTouch: this.isMobileOrTouch,
        provider: {
          isCoinbaseWallet: this.provider ? this.provider.isCoinbaseWallet : null,
          isCoinbaseBrowser: this.provider ? this.provider.isCoinbaseBrowser : null,
          isMetaMask: this.provider ? this.provider.isMetaMask : null,
          isRabby: this.provider ? this.provider.isRabby : null,
          isSmartWallet: this.isSmartWallet
        }
      };
      return userEnv;
    },
    saveEvent: function saveEvent(eventType, eventData) {
      var userEnv = this.getEventUserEnv();
      this.postToLambda('saveEvent', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, userEnv, {
        eventType: eventType,
        eventData: eventData
      }));
    },
    getRefCode: function () {
      var _ref37 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee32() {
        var userEnv, response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (!(!this.refCode && this.connectAccountAddress)) {
                  _context32.next = 6;
                  break;
                }

                userEnv = this.getEventUserEnv();
                _context32.next = 4;
                return this.postToLambda('getRefCode', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, userEnv));

              case 4:
                response = _context32.sent;

                if (response && response.code) {
                  this.refCode = response.code;
                }

              case 6:
                return _context32.abrupt('return', this.refCode);

              case 7:
              case 'end':
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function getRefCode() {
        return _ref37.apply(this, arguments);
      }

      return getRefCode;
    }(),
    handleWalletError: function handleWalletError(errMsg) {
      var userEnv = this.getEventUserEnv();
      this.postToLambda('walletError', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, userEnv, {
        error: errMsg
      }));
      if (errMsg && errMsg.message) {
        errMsg = errMsg.message;
      }
      if (!errMsg) {
        this.showAlert('An error occurred.');
      } else if (errMsg.includes('Insufficient payment')) {
        this.showAlert('Insufficient funds for plot. Please reload the page and try again.');
        trackEvent('walletError:plotClaimed');
      } else if (errMsg.includes('Coordinates overlap')) {
        this.showAlert('This plot has already been claimed.');
        trackEvent('walletError:plotClaimed');
      } else if (errMsg.includes('insufficient funds')) {
        this.showAlert('Insufficient funds for transaction.');
        trackEvent('walletError:insufficientFunds');
      } else if (errMsg.includes('user rejected action')) {
        this.showAlert('User rejected transaction.');
        trackEvent('walletError:reject');
      } else if (errMsg.includes('ERC20: insufficient allowance')) {
        this.showAlert('Please approve the token transfer first.');
        trackEvent('walletError:approve');
      } else if (errMsg.includes('execution reverted') || errMsg.includes('missing revert data')) {
        this.showAlert('Transaction would be reverted.');
        trackEvent('walletError:revert');
      } else {
        this.showAlert(errMsg);
        trackEvent('walletError:unknown');
      }
    },
    // The cached ethers provider/signer are bound to one account and network.
    resetProviderSigner: function resetProviderSigner() {
      this.browserProvider = null;
      this.browserProviderSigner = null;
    },
    getProviderSigner: function () {
      var _ref38 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee33() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.ensureBaseChain(this.provider);

              case 2:
                if (this.browserProvider) {
                  _context33.next = 9;
                  break;
                }

                _context33.next = 5;
                return new ethers.BrowserProvider(this.provider);

              case 5:
                this.browserProvider = _context33.sent;
                _context33.next = 8;
                return this.browserProvider.getSigner();

              case 8:
                this.browserProviderSigner = _context33.sent;

              case 9:
                log('getProviderSigner', this.browserProvider, this.browserProviderSigner);
                return _context33.abrupt('return', {
                  provider: this.browserProvider,
                  signer: this.browserProviderSigner
                });

              case 11:
              case 'end':
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function getProviderSigner() {
        return _ref38.apply(this, arguments);
      }

      return getProviderSigner;
    }(),
    sendEtherFrom: function () {
      var _ref39 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee34(account, donation_amount, isEth, callback) {
        var link_url_el, link_url, pixels_data_strs, r, c, pixels_data_str, pixels_data_gzip_str, trxAmount, _ref40, provider, signer, balance, transactionRequest, estimatedGas, gasLimit, transactionRequestWithGasLimit, tx, receipt, hash;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                trackEvent('trxSending');
                link_url_el = document.getElementById('link-url');
                link_url = link_url_el.value;


                log('donation amount', donation_amount, typeof donation_amount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(donation_amount));
                log('link url', link_url);

                if (!(link_url.indexOf('http') !== 0)) {
                  _context34.next = 10;
                  break;
                }

                this.showAlert('Please provide a URL your image should link to for when someone clicks on it.');
                link_url_el.focus();
                this.buyLoading = false;
                return _context34.abrupt('return', false);

              case 10:
                pixels_data_strs = [];

                for (r in window.segmentPrices) {
                  for (c in window.segmentPrices[r]) {
                    pixels_data_strs.push(stringDataForEth(window.pixels_data[r][c], link_url, window.segmentPrices[r][c], r, c));
                  }
                }

                log('pixels_data_strs', pixels_data_strs);
                pixels_data_str = pixels_data_strs.join('\n');
                pixels_data_gzip_str = pako.deflate(pixels_data_str, { to: 'string' });

                // log('pixels_data_str: '+pixels_data_str);

                log('pixels_data_str length: ' + pixels_data_str.length);
                log('pixels_data_gzip_str length: ' + pixels_data_gzip_str.length);
                log('compression ratio: ' + pixels_data_str.length / pixels_data_gzip_str.length);

                if (!this.demoMode) {
                  _context34.next = 21;
                  break;
                }

                callback();
                return _context34.abrupt('return');

              case 21:
                if (isEth) {
                  _context34.next = 30;
                  break;
                }

                if (!this.canMint) {
                  _context34.next = 27;
                  break;
                }

                _context34.next = 25;
                return this.sendPixelsToTokenNFT(pixels_data_gzip_str, donation_amount, account, callback);

              case 25:
                _context34.next = 29;
                break;

              case 27:
                _context34.next = 29;
                return this.sendPixelsToToken(pixels_data_gzip_str, donation_amount, account, callback);

              case 29:
                return _context34.abrupt('return');

              case 30:
                if (!this.canMint) {
                  _context34.next = 34;
                  break;
                }

                _context34.next = 33;
                return this.sendPixelsToNFT(pixels_data_gzip_str, donation_amount, account, callback);

              case 33:
                return _context34.abrupt('return');

              case 34:
                _context34.prev = 34;
                trxAmount = ethers.parseEther(donation_amount);

                log('trxAmount', trxAmount, typeof trxAmount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(trxAmount));

                _context34.next = 39;
                return this.getProviderSigner();

              case 39:
                _ref40 = _context34.sent;
                provider = _ref40.provider;
                signer = _ref40.signer;

                if (!this.requireEthBalance) {
                  _context34.next = 52;
                  break;
                }

                _context34.next = 45;
                return provider.getBalance(account);

              case 45:
                balance = _context34.sent;

                log('balance', balance.toString(), trxAmount.toString());

                if (!(balance < trxAmount)) {
                  _context34.next = 52;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Insufficient funds for transaction.');
                this.saveEvent('insufficientFunds', {
                  trxAmount: trxAmount.toString(),
                  balance: balance.toString()
                });
                return _context34.abrupt('return');

              case 52:

                // console.log("SEND", account, provider, signer);
                transactionRequest = {
                  to: BID_TO_ADDRESS,
                  value: trxAmount,
                  data: getEncodedEthDataValue(pixels_data_gzip_str)
                };
                _context34.next = 55;
                return signer.estimateGas(transactionRequest);

              case 55:
                estimatedGas = _context34.sent;
                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                transactionRequestWithGasLimit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, transactionRequest, {
                  gasLimit: gasLimit
                });


                this.saveEvent('trxReq', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, transactionRequestWithGasLimit, {
                  gasLimit: transactionRequestWithGasLimit.gasLimit.toString(),
                  value: transactionRequestWithGasLimit.value.toString()
                }));

                _context34.next = 61;
                return signer.sendTransaction(transactionRequestWithGasLimit);

              case 61:
                tx = _context34.sent;
                _context34.next = 64;
                return tx.wait();

              case 64:
                receipt = _context34.sent;
                hash = receipt.hash;

                log('receipt', receipt, hash);
                trackEvent('trxSent');
                this.pollForCompletion(hash, callback);
                this.resetBuy();
                _context34.next = 78;
                break;

              case 72:
                _context34.prev = 72;
                _context34.t0 = _context34['catch'](34);

                trackEvent('trxFailed');
                console.error('Error sending:', _context34.t0);
                this.buyLoading = false;
                this.handleWalletError(_context34.t0);

              case 78:
              case 'end':
                return _context34.stop();
            }
          }
        }, _callee34, this, [[34, 72]]);
      }));

      function sendEtherFrom(_x40, _x41, _x42, _x43) {
        return _ref39.apply(this, arguments);
      }

      return sendEtherFrom;
    }(),
    sendPixelsToNFT: function () {
      var _ref41 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee35(pixels_data_gzip_str, donation_amount, account, callback) {
        var trxAmount,
            x1,
            y1,
            x2,
            y2,
            _ref42,
            provider,
            signer,
            nftContract,
            calculatedPrice,
            balance,
            gasLimit,
            estimatedGas,
            overrides,
            receipt,
            txHash,
            _args35 = arguments;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                log('sendPixelsToNFT', _args35);
                trackEvent('sendPixelsToNFT');

                trxAmount = ethers.parseEther(donation_amount);

                log('trxAmount', trxAmount, typeof trxAmount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(trxAmount));

                x1 = window.img_offset_x;
                y1 = window.img_offset_y;
                x2 = window.img_offset_x + window.img_width;
                y2 = window.img_offset_y + window.img_height;
                _context35.prev = 8;
                _context35.next = 11;
                return this.getProviderSigner();

              case 11:
                _ref42 = _context35.sent;
                provider = _ref42.provider;
                signer = _ref42.signer;
                nftContract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, signer);

                // Someone may have minted this spot since the image was placed.

                _context35.next = 17;
                return this.isPlotTaken(nftContract, x1, y1, x2, y2);

              case 17:
                if (!_context35.sent) {
                  _context35.next = 22;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('This plot has already been claimed.');
                trackEvent('walletError:plotClaimed');
                return _context35.abrupt('return');

              case 22:
                _context35.next = 24;
                return nftContract.calculateCurrentPrice(x1, y1, x2, y2);

              case 24:
                calculatedPrice = _context35.sent;

                log('calculatedPrice', calculatedPrice, typeof calculatedPrice === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(calculatedPrice), ethers.formatEther(calculatedPrice));
                if (calculatedPrice !== trxAmount) {
                  this.saveEvent('priceAdjusted', {
                    from: trxAmount.toString(),
                    to: calculatedPrice.toString()
                  });
                  trxAmount = calculatedPrice;
                  this.ethAmt = ethers.formatEther(calculatedPrice);
                }

                if (!this.requireEthBalance) {
                  _context35.next = 37;
                  break;
                }

                _context35.next = 30;
                return provider.getBalance(account);

              case 30:
                balance = _context35.sent;

                log('balance', balance.toString(), trxAmount.toString());

                if (!(balance < trxAmount)) {
                  _context35.next = 37;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('Insufficient funds for transaction.');
                this.saveEvent('insufficientFunds', {
                  trxAmount: trxAmount.toString(),
                  balance: balance.toString()
                });
                return _context35.abrupt('return');

              case 37:
                gasLimit = 10000000; // Fallback if we fail to get an estimate

                estimatedGas = void 0;
                _context35.prev = 39;
                _context35.next = 42;
                return nftContract.mint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, {
                  value: trxAmount,
                  gasLimit: 10000000 // Set a high gas to try to get the node to estimate beyond 1M
                });

              case 42:
                estimatedGas = _context35.sent;

                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                _context35.next = 50;
                break;

              case 46:
                _context35.prev = 46;
                _context35.t0 = _context35['catch'](39);

                console.error('Error estimating gas:', _context35.t0);
                // Save error event
                this.saveEvent('estimateGasErr', {
                  msg: _context35.t0.message || ''
                });

              case 50:
                overrides = {
                  gasLimit: gasLimit,
                  value: trxAmount
                };


                this.saveEvent('trxReq', {
                  gasLimit: gasLimit.toString(),
                  value: trxAmount.toString()
                });
                _context35.next = 54;
                return nftContract.mint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str, overrides);

              case 54:
                receipt = _context35.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context35.next = 68;
                break;

              case 62:
                _context35.prev = 62;
                _context35.t1 = _context35['catch'](8);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context35.t1);
                this.handleWalletError(_context35.t1);

              case 68:
              case 'end':
                return _context35.stop();
            }
          }
        }, _callee35, this, [[8, 62], [39, 46]]);
      }));

      function sendPixelsToNFT(_x44, _x45, _x46, _x47) {
        return _ref41.apply(this, arguments);
      }

      return sendPixelsToNFT;
    }(),
    isPlotTaken: function () {
      var _ref43 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee36(nftContract, x1, y1, x2, y2) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.prev = 0;
                _context36.next = 3;
                return nftContract.checkOverlap(x1, y1, x2, y2);

              case 3:
                return _context36.abrupt('return', _context36.sent);

              case 6:
                _context36.prev = 6;
                _context36.t0 = _context36['catch'](0);

                // Never block a mint because the check itself failed.
                log('checkOverlap failed', _context36.t0);
                return _context36.abrupt('return', false);

              case 10:
              case 'end':
                return _context36.stop();
            }
          }
        }, _callee36, this, [[0, 6]]);
      }));

      function isPlotTaken(_x48, _x49, _x50, _x51, _x52) {
        return _ref43.apply(this, arguments);
      }

      return isPlotTaken;
    }(),
    checkCanPayWithToken: function () {
      var _ref44 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee37(tokenOnly) {
        var _ref45, provider, signer, token, existingBalance;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (this.connectAccountAddress) {
                  _context37.next = 2;
                  break;
                }

                return _context37.abrupt('return');

              case 2:
                _context37.prev = 2;
                _context37.next = 5;
                return this.getProviderSigner();

              case 5:
                _ref45 = _context37.sent;
                provider = _ref45.provider;
                signer = _ref45.signer;
                token = new ethers.Contract(this.contractAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);
                _context37.next = 11;
                return token.balanceOf(this.connectAccountAddress);

              case 11:
                existingBalance = _context37.sent;


                console.log('Existing balance:', this.contractAddress, existingBalance.toString());

                if (existingBalance > 0) {
                  // if this route page is "tang"
                  if (this.$route.path === '/tang' || this.$route.path === '/dob' || this.$route.path === '/zora') {
                    tokenOnly = true;
                  }
                  if (!tokenOnly) {
                    this.canToggleEthToken = true;
                  }
                } else {
                  this.canToggleEthToken = false;
                }
                _context37.next = 20;
                break;

              case 16:
                _context37.prev = 16;
                _context37.t0 = _context37['catch'](2);

                console.error('Error checking token balance:', _context37.t0);
                this.canToggleEthToken = false;

              case 20:
              case 'end':
                return _context37.stop();
            }
          }
        }, _callee37, this, [[2, 16]]);
      }));

      function checkCanPayWithToken(_x53) {
        return _ref44.apply(this, arguments);
      }

      return checkCanPayWithToken;
    }(),
    getSwapAmountIn: function () {
      var _ref46 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee38(contractAddress, amount) {
        var _ref47, provider, signer, quoter, tokenContract, decimals, params, quotedAmountOut, tokenPriceInETH;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!amount) {
                  amount = 1;
                }
                log('getSwapAmountIn', amount, typeof amount === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(amount));
                _context38.next = 4;
                return this.getProviderSigner();

              case 4:
                _ref47 = _context38.sent;
                provider = _ref47.provider;
                signer = _ref47.signer;
                quoter = new ethers.Contract(UNISWAP_QUOTER_V3, [{
                  "inputs": [{
                    "components": [{
                      "internalType": "address",
                      "name": "tokenIn",
                      "type": "address"
                    }, {
                      "internalType": "address",
                      "name": "tokenOut",
                      "type": "address"
                    }, {
                      "internalType": "uint256",
                      "name": "amountIn",
                      "type": "uint256"
                    }, {
                      "internalType": "uint24",
                      "name": "fee",
                      "type": "uint24"
                    }, {
                      "internalType": "uint160",
                      "name": "sqrtPriceLimitX96",
                      "type": "uint160"
                    }],
                    "internalType": "struct IQuoterV2.QuoteExactInputSingleParams",
                    "name": "params",
                    "type": "tuple"
                  }],
                  "name": "quoteExactInputSingle",
                  "outputs": [{
                    "internalType": "uint256",
                    "name": "amountOut",
                    "type": "uint256"
                  }, {
                    "internalType": "uint160",
                    "name": "sqrtPriceX96After",
                    "type": "uint160"
                  }, {
                    "internalType": "uint32",
                    "name": "initializedTicksCrossed",
                    "type": "uint32"
                  }, {
                    "internalType": "uint256",
                    "name": "gasEstimate",
                    "type": "uint256"
                  }],
                  "stateMutability": "nonpayable",
                  "type": "function"
                }], provider);

                // // Get the token decimals

                tokenContract = new ethers.Contract(contractAddress, ["function decimals() external view returns (uint8)"], provider);

                console.log('tokenContract', tokenContract);
                _context38.next = 12;
                return tokenContract.decimals();

              case 12:
                decimals = _context38.sent;

                console.log('Token Decimals: ' + decimals);

                // Simulate swapping 1 token to get price in WETH
                // const amountIn = ethers.parseUnits(amount.toString(), decimals); // Querying price for 1 token

                params = {
                  tokenIn: contractAddress,
                  tokenOut: WETH_ADDRESS,
                  amountIn: amount,
                  fee: FEE_TIER,
                  sqrtPriceLimitX96: 0 // No price limit
                };

                log(params);

                _context38.prev = 16;

                console.log('quoter', quoter);
                _context38.next = 20;
                return quoter.quoteExactInputSingle.staticCall(params);

              case 20:
                quotedAmountOut = _context38.sent;

                // console.log(`Quoted Amount Out: ${JSON.stringify(quotedAmountOut)}`);
                tokenPriceInETH = Number(ethers.formatUnits(quotedAmountOut[0], 18));

                console.log('Price for ' + amount + ' tokens is ' + tokenPriceInETH + ' ETH');
                return _context38.abrupt('return', { tokenPriceInETH: quotedAmountOut[0], decimals: decimals });

              case 26:
                _context38.prev = 26;
                _context38.t0 = _context38['catch'](16);

                console.log(_context38.t0);
                throw new Error(_context38.t0);

              case 30:
              case 'end':
                return _context38.stop();
            }
          }
        }, _callee38, this, [[16, 26]]);
      }));

      function getSwapAmountIn(_x54, _x55) {
        return _ref46.apply(this, arguments);
      }

      return getSwapAmountIn;
    }(),
    previewSwap: function () {
      var _ref48 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee39(amount) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
              case 'end':
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function previewSwap(_x56) {
        return _ref48.apply(this, arguments);
      }

      return previewSwap;
    }(),
    doSwap: function () {
      var _ref49 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee40(amount) {
        var _this5 = this;

        var _ref50, tokenPriceInETH, decimals, tokenPriceInETHWithSlippage, _ref51, provider, signer, routerAbi, router, params, tx, txHash;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                log('doSwap', amount);
                this.swapLoading = true;
                this.$bvModal.hide('modal-alert');

                _context40.next = 5;
                return this.getSwapAmountIn(this.contractAddress, amount);

              case 5:
                _ref50 = _context40.sent;
                tokenPriceInETH = _ref50.tokenPriceInETH;
                decimals = _ref50.decimals;


                // Account for slippage
                tokenPriceInETHWithSlippage = tokenPriceInETH * BigInt(105) / BigInt(100);
                _context40.next = 11;
                return this.getProviderSigner();

              case 11:
                _ref51 = _context40.sent;
                provider = _ref51.provider;
                signer = _ref51.signer;
                routerAbi = ['function exactInputSingle(tuple(address tokenIn, address tokenOut, uint24 fee, address recipient, uint256 amountIn, uint256 amountOutMinimum, uint160 sqrtPriceLimitX96)) returns (uint256 amountOut)'];
                router = new ethers.Contract(UNISWAP_ROUTER_V3, routerAbi, signer);

                log('router', router);
                params = {
                  tokenIn: WETH_ADDRESS,
                  tokenOut: this.contractAddress,
                  fee: FEE_TIER,
                  recipient: this.connectAccountAddress,
                  amountIn: tokenPriceInETHWithSlippage,
                  amountOutMinimum: amount,
                  sqrtPriceLimitX96: 0 // No price limit
                };

                log(params);
                log(tokenPriceInETHWithSlippage);

                _context40.prev = 20;
                _context40.next = 23;
                return router.exactInputSingle(params, {
                  value: tokenPriceInETHWithSlippage // ethers.formatEther(tokenPriceInETHWithSlippage, 18),
                });

              case 23:
                tx = _context40.sent;

                log('Transaction receipt:', tx);
                txHash = tx.hash;

                this.pollForCompletion(txHash, function (err, transaction) {
                  if (err) {
                    console.error('Error in transaction:', err);
                    _this5.swapLoading = false;
                    return;
                  }
                  log('Transaction completed:', transaction);
                  _this5.swapLoading = false;
                  _this5.showAlert('Swap complete!');
                  trackEvent('swapSuccess');
                });
                _context40.next = 34;
                break;

              case 29:
                _context40.prev = 29;
                _context40.t0 = _context40['catch'](20);

                trackEvent('swapFailed');
                console.error('Error sawpping:', _context40.t0);
                this.handleWalletError(_context40.t0);

              case 34:
              case 'end':
                return _context40.stop();
            }
          }
        }, _callee40, this, [[20, 29]]);
      }));

      function doSwap(_x57) {
        return _ref49.apply(this, arguments);
      }

      return doSwap;
    }(),
    sendPixelsToTokenNFT: function () {
      var _ref52 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee41(pixels_data_gzip_str, donation_amount, account, callback) {
        var trxAmount,
            _ref53,
            provider,
            signer,
            nftContract,
            tokenContract,
            existingBalance,
            amtNeeded,
            approveTrx,
            approveReceipt,
            receipt,
            txHash,
            _args41 = arguments;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                log('sendPixelsToTokenNFT', _args41);
                trackEvent('sendPixelsToTokenNFT');

                trxAmount = ethers.parseUnits(donation_amount, 18);

                // const x1 = window.img_offset_x;
                // const y1 = window.img_offset_y;
                // const x2 = window.img_offset_x + window.img_width;
                // const y2 = window.img_offset_y + window.img_height;

                _context41.prev = 3;
                _context41.next = 6;
                return this.getProviderSigner();

              case 6:
                _ref53 = _context41.sent;
                provider = _ref53.provider;
                signer = _ref53.signer;
                nftContract = new ethers.Contract(this.nftAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].NFT_ABI, signer);
                tokenContract = new ethers.Contract(this.contractAddress, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);

                // Check balance is enough for the transaction

                _context41.next = 13;
                return tokenContract.balanceOf(account);

              case 13:
                existingBalance = _context41.sent;

                console.log('Existing balance: ' + existingBalance.toString() + ', donation amount: ' + donation_amount);

                if (!(existingBalance < trxAmount)) {
                  _context41.next = 20;
                  break;
                }

                this.buyLoading = false;
                amtNeeded = trxAmount - existingBalance;

                this.showAlert('You don\'t have enough ' + this.symbol + ' for this transaction', {
                  amountNeeded: amtNeeded,
                  amountNeededFormatted: parseFloat(ethers.formatEther(amtNeeded)).toFixed(0)
                });
                return _context41.abrupt('return');

              case 20:
                _context41.next = 22;
                return tokenContract.approve(this.nftAddress, trxAmount);

              case 22:
                approveTrx = _context41.sent;

                console.log('Approved ' + trxAmount + ' tokens for NFT contract:', approveTrx);
                _context41.next = 26;
                return approveTrx.wait();

              case 26:
                approveReceipt = _context41.sent;

                console.log('Approval receipt:', approveReceipt);

                // const estimatedGas = await nftContract.tokenMint.estimateGas(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);
                // const gasLimit = this.getGasLimitFromEstimate(estimatedGas);

                // const overrides = {
                //   gasLimit: gasLimit,
                //   // value: trxAmount,
                // };

                _context41.next = 30;
                return nftContract.tokenMint(window.img_offset_x, window.img_offset_y, window.img_offset_x + window.img_width, window.img_offset_y + window.img_height, pixels_data_gzip_str);

              case 30:
                receipt = _context41.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context41.next = 44;
                break;

              case 38:
                _context41.prev = 38;
                _context41.t0 = _context41['catch'](3);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context41.t0);
                this.handleWalletError(_context41.t0);

              case 44:
              case 'end':
                return _context41.stop();
            }
          }
        }, _callee41, this, [[3, 38]]);
      }));

      function sendPixelsToTokenNFT(_x58, _x59, _x60, _x61) {
        return _ref52.apply(this, arguments);
      }

      return sendPixelsToTokenNFT;
    }(),
    sendPixelsToToken: function () {
      var _ref54 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee42(pixels_data_gzip_str, donation_amount, account, callback) {
        var amount,
            _ref55,
            provider,
            signer,
            token,
            existingBalance,
            estimatedGas,
            gasLimit,
            overrides,
            receipt,
            txHash,
            _args42 = arguments;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                log('sendPixelsToToken', _args42);
                trackEvent('sendPixelsToToken');

                amount = ethers.parseUnits(donation_amount, 18);
                _context42.prev = 3;
                _context42.next = 6;
                return this.getProviderSigner();

              case 6:
                _ref55 = _context42.sent;
                provider = _ref55.provider;
                signer = _ref55.signer;
                token = new ethers.Contract(__WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_CA, __WEBPACK_IMPORTED_MODULE_12__config__["a" /* default */].TOKEN_ABI, signer);
                _context42.next = 12;
                return token.balanceOf(account);

              case 12:
                existingBalance = _context42.sent;

                if (!(existingBalance < amount)) {
                  _context42.next = 17;
                  break;
                }

                this.buyLoading = false;
                this.showAlert('You don\'t have enough ' + this.symbol + ' for this transaction');
                return _context42.abrupt('return');

              case 17:
                _context42.next = 19;
                return token.paint.estimateGas(BID_TO_ADDRESS, amount, pixels_data_gzip_str);

              case 19:
                estimatedGas = _context42.sent;
                gasLimit = this.getGasLimitFromEstimate(estimatedGas);
                overrides = {
                  gasLimit: gasLimit
                };
                _context42.next = 24;
                return token.paint(BID_TO_ADDRESS, amount, pixels_data_gzip_str, overrides);

              case 24:
                receipt = _context42.sent;

                trackEvent('trxSent');
                console.log('Transaction receipt:', receipt);
                txHash = receipt.hash;

                this.pollForCompletion(txHash, callback);
                this.resetBuy();
                _context42.next = 38;
                break;

              case 32:
                _context42.prev = 32;
                _context42.t0 = _context42['catch'](3);

                this.buyLoading = false;
                trackEvent('trxFailed');
                console.error('Error sending:', _context42.t0);
                this.handleWalletError(_context42.t0);

              case 38:
              case 'end':
                return _context42.stop();
            }
          }
        }, _callee42, this, [[3, 32]]);
      }));

      function sendPixelsToToken(_x62, _x63, _x64, _x65) {
        return _ref54.apply(this, arguments);
      }

      return sendPixelsToToken;
    }(),
    getGasLimitFromEstimate: function getGasLimitFromEstimate(estimatedGas) {
      var gasLimit = estimatedGas * BigInt(1000) / BigInt(100); // 10x the gas price for coinbase mobile wallet
      log('Estimated gas: ' + estimatedGas + ', gasLimit: ' + gasLimit);
      return gasLimit;
    },
    showAlert: function showAlert(msg, swapOpts) {
      this.alertMsg = msg;
      this.alertSwapOpts = swapOpts;
      this.$bvModal.show('modal-alert');
    },
    hasProvider: function hasProvider(name) {
      return this.providers.find(function (p) {
        return p.info.name === name;
      });
    },
    pushProvider: function pushProvider(p) {
      var _this6 = this;

      log('Found provider', p);
      if (!listenedProviders.has(p)) {
        listenedProviders.add(p);
        p.on("accountsChanged", function (accounts) {
          log('accountsChanged', accounts);
          // Once connected, only the wallet in use may change the session.
          if (_this6.provider && _this6.provider !== p) {
            return;
          }
          _this6.resetProviderSigner();
          _this6.getWalletPermissions(p, accounts);
        });
        p.on("chainChanged", function (chainId) {
          log('chainChanged', chainId, typeof chainId === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(chainId));
          if (_this6.provider && _this6.provider !== p) {
            return;
          }
          _this6.resetProviderSigner();
          _this6.connectAccountChainId = chainId;
        });
      }
      // p.on("disconnect", (error) => {
      //   log('disconnect', error);
      //   this.getWalletPermissions(event.detail.provider);
      // });
      if (p.isPhantom) {
        log('Phantom provider', p);
        if (!this.hasProvider('Phantom')) {
          this.providers.push({
            provider: p,
            info: {
              "uuid": "1",
              "name": "Phantom",
              "icon": "data:image/png;base64,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\n",
              "rdns": "app.phantom"
            }
          });
        }
        this.getWalletPermissions(p);
        trackEvent('hasWallet:app.phantom');
        return;
      }
      if (p.isMetaMask) {
        if (p.isRabby) {
          log('Rabby provider', p);
          this.providers.push({
            provider: p,
            info: {
              "uuid": "aba7b19c-2e24-4405-aff2-69dbd5bbfafd",
              "name": "Rabby",
              "icon": "data:image/svg+xml;base64,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",
              "rdns": "io.rabby"
            }
          });
          this.getWalletPermissions(p);
          trackEvent('hasWallet:io.rabby');
          return;
        }
        log('MetaMask provider', p);
        this.providers.push({
          provider: p,
          info: {
            "uuid": "eb90892c-6a12-44c9-9aea-31a4dd915385",
            "name": "MetaMask",
            "icon": "data:image/svg+xml;base64,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",
            "rdns": "io.metamask"
          }
        });
        this.getWalletPermissions(p);
        trackEvent('hasWallet:io.metamask');
      } else if (p.isCoinbaseWallet || p.isCoinbaseBrowser) {
        log('Coinbase Wallet provider', p);
        this.providers.push({
          provider: p,
          info: {
            "uuid": "22c494ca-e7ca-4c13-a5c0-6d72312046a6",
            "name": "Coinbase",
            "icon": "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI4IDU2YzE1LjQ2NCAwIDI4LTEyLjUzNiAyOC0yOFM0My40NjQgMCAyOCAwIDAgMTIuNTM2IDAgMjhzMTIuNTM2IDI4IDI4IDI4WiIgZmlsbD0iIzFCNTNFNCIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAyOGMwIDExLjU5OCA5LjQwMiAyMSAyMSAyMXMyMS05LjQwMiAyMS0yMVMzOS41OTggNyAyOCA3IDcgMTYuNDAyIDcgMjhabTE3LjIzNC02Ljc2NmEzIDMgMCAwIDAtMyAzdjcuNTMzYTMgMyAwIDAgMCAzIDNoNy41MzNhMyAzIDAgMCAwIDMtM3YtNy41MzNhMyAzIDAgMCAwLTMtM2gtNy41MzNaIiBmaWxsPSIjZmZmIi8+PC9zdmc+",
            "rdns": "com.coinbase.wallet"
          }
        });
        trackEvent('hasWallet:com.coinbase.wallet');
      } else {
        log('Unknown provider', p);
        trackEvent('hasWallet:unknown');
      }
    },
    blurInput: function blurInput() {
      this.$refs.formInputValueUrl.blur();
    },
    initPushNotification: function initPushNotification() {
      var _this7 = this;

      if (!('serviceWorker' in navigator)) {
        // alert('No Service Worker support!')
        return;
      }
      // if (!('PushManager' in window)) {
      //   alert('No Push API Support!')
      //   return;
      // }

      // if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push are supported');

      // Notification.requestPermission().then(async () => {
      navigator.serviceWorker.register('sw.js').then(function (swReg) {
        // alert('Service Worker is registered', swReg);
        _this7.swRegistration = swReg;
        _this7.initSubscription();
      }).catch(function (error) {
        // alert('Service Worker Error', error);
        // alert(JSON.stringify(error));
      });
      // });
      // } else {
      //   console.warn('Push messaging is not supported');
      //   pushButton.textContent = 'Push Not Supported';
      // }
    },
    initSubscription: function initSubscription() {
      var _this8 = this;

      // Set the initial subscription value
      this.swRegistration.pushManager.getSubscription().then(function (subscription) {
        _this8.isSubscribed = !(subscription === null);
        _this8.updateSubscriptionOnServer(subscription);

        if (_this8.isSubscribed) {
          console.log('User IS subscribed.', subscription);
        } else {
          console.log('User is NOT subscribed.');
          _this8.subscribeUser();
        }
      }).catch(function (error) {
        // alert('Error during getSubscription()', error);
      });
    },

    postToLambda: function () {
      var _ref56 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee43(name, data) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                log('Posting data to lambda', name, data);
                _context43.prev = 1;
                _context43.next = 4;
                return fetch(PUSH_SUB_URL + name, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data)
                });

              case 4:
                response = _context43.sent;

                if (!response.ok) {
                  _context43.next = 7;
                  break;
                }

                return _context43.abrupt('return', response.json());

              case 7:
                _context43.next = 13;
                break;

              case 9:
                _context43.prev = 9;
                _context43.t0 = _context43['catch'](1);

                console.error('Fetch error:', _context43.t0);
                return _context43.abrupt('return', undefined);

              case 13:
              case 'end':
                return _context43.stop();
            }
          }
        }, _callee43, this, [[1, 9]]);
      }));

      function postToLambda(_x66, _x67) {
        return _ref56.apply(this, arguments);
      }

      return postToLambda;
    }(),
    updateSubscriptionOnServer: function updateSubscriptionOnServer(subscription) {
      localStorage.setItem(LOCAL_STORAGE_NOTIFICATION_SUB_ENDPOINT, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(subscription.endpoint));
      if (subscription) {
        console.log('updateSubscriptionOnServer', subscription);
        try {
          fetch(PUSH_SUB_URL + 'subscribe', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(subscription)
          }).then(function (response) {
            if (!response.ok) {
              console.error('Network response was not ok ' + response.statusText);
            }
            trackEvent('pushSubscribed');
            return response.json(); // Assuming the response is JSON
          }).then(function (data) {
            console.log('Data received:', data);
          }).catch(function (error) {
            console.error('Fetch error:', error);
          });
          __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].toast({
            title: 'Million Bit Homepage',
            message: 'Notifications enabled',
            type: "success",
            duration: 5000
          });
        } catch (e) {
          console.error('Fetch error:', e);
        }
      }
      // TODO: Send subscription to application server

      // const subscriptionJson = document.querySelector('.js-subscription-json');
      // const subscriptionDetails =
      //   document.querySelector('.js-subscription-details');

      // if (subscription) {
      //   subscriptionJson.textContent = JSON.stringify(subscription);
      //   subscriptionDetails.classList.remove('is-invisible');
      // } else {
      //   subscriptionDetails.classList.add('is-invisible');
      // }
    },
    subscribeUser: function subscribeUser() {
      var _this9 = this;

      var applicationServerKey = urlB64ToUint8Array(applicationServerPublicKey);
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      }).then(function (subscription) {
        console.log('User is subscribed', subscription);

        _this9.updateSubscriptionOnServer(subscription);

        _this9.isSubscribed = true;

        // updateBtn();
      }).catch(function (err) {
        console.log('Failed to subscribe the user: ', err);
        // updateBtn();
      });
    },

    showInviteFriends: function () {
      var _ref57 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee44() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                _context44.next = 2;
                return this.getRefCode();

              case 2:
                this.$bvModal.show('modal-invite-friends');

              case 3:
              case 'end':
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function showInviteFriends() {
        return _ref57.apply(this, arguments);
      }

      return showInviteFriends;
    }(),
    moveImage: function moveImage(dx, dy, toAbsolute) {
      var image = document.getElementById('uploadedImg');
      var imageX = parseFloat(image.getAttribute('data-x')) || 0;
      var imageY = parseFloat(image.getAttribute('data-y')) || 0;
      if (toAbsolute) {
        dx = dx - imageX;
        dy = dy - imageY;
      }
      var x = imageX + dx;
      var y = imageY + dy;

      // Apply the transformation
      image.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

      // Update the position attributes
      image.setAttribute('data-x', x);
      image.setAttribute('data-y', y);

      // window.img_offset_x = x;
      // window.img_offset_y = y;
      setImageOffset(x, y);
    },
    moveSpot: function moveSpot(direction) {
      if (direction === 'left') {
        this.moveImage(-16, 0);
      } else if (direction === 'right') {
        this.moveImage(16, 0);
      } else if (direction === 'up') {
        this.moveImage(0, -16);
      } else if (direction === 'down') {
        this.moveImage(0, 16);
      }
      this.validateImageLocation(window.img_offset_x, window.img_offset_y, window.img_width, window.img_height);
      window.interactable.reflow({ name: 'drag', axis: 'xy' });
    },
    resizeSpot: function resizeSpot(direction) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee46() {
        var scaleImage;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                scaleImage = function () {
                  var _ref58 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee45(increment) {
                    var image, currentWidth, currentHeight, newWidth, newHeight;
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
                      while (1) {
                        switch (_context45.prev = _context45.next) {
                          case 0:
                            image = document.getElementById('uploadedImg');
                            currentWidth = image.offsetWidth;
                            currentHeight = image.offsetHeight;

                            if (!(direction === 'bigger' && (currentHeight >= MAX_IMAGE_SIZE || currentWidth >= MAX_IMAGE_SIZE) || direction === 'smaller' && (currentHeight <= 16 || currentWidth <= 16))) {
                              _context45.next = 5;
                              break;
                            }

                            return _context45.abrupt('return');

                          case 5:

                            // Calculate the new dimensions
                            newWidth = currentWidth + increment;
                            newHeight = currentHeight + increment;

                            // Ensure the image doesn't scale down below a minimum size (e.g., 16x16 pixels)

                            if (!(newWidth >= 16 && newHeight >= 16)) {
                              _context45.next = 10;
                              break;
                            }

                            _context45.next = 10;
                            return setImageSize(_this10, newWidth, newHeight);

                          case 10:
                          case 'end':
                            return _context45.stop();
                        }
                      }
                    }, _callee45, _this10);
                  }));

                  return function scaleImage(_x68) {
                    return _ref58.apply(this, arguments);
                  };
                }();

                if (direction === 'bigger') {
                  scaleImage(16);
                } else if (direction === 'smaller') {
                  scaleImage(-16);
                }
                window.interactable.reflow({ name: 'drag', axis: 'xy' });

              case 3:
              case 'end':
                return _context46.stop();
            }
          }
        }, _callee46, _this10);
      }))();
    },
    btnPress: function btnPress(direction) {
      // Your button press logic here
      this.moveSpot(direction);
    },
    handleTouchStart: function handleTouchStart(event, direction) {
      var _this11 = this;

      event.preventDefault(); // Prevents text selection and default touch behavior
      // Call btnPress immediately
      this.btnPress(direction);
      this.touchTimer = setTimeout(function () {
        // Start repeating every 500ms
        _this11.repeatTimer = setInterval(function () {
          _this11.btnPress(direction);
        }, 100);
      }, 500); // Adjust this timeout for long press sensitivity
    },
    handleTouchEnd: function handleTouchEnd(event) {
      event.preventDefault(); // Prevents zooming
      this.handleTouchCancel();
    },
    handleTouchCancel: function handleTouchCancel() {
      clearTimeout(this.touchTimer);
      clearInterval(this.repeatTimer);
    },

    loadProviders: function loadProviders() {
      if (this.providers.length === 0) {
        if (window.ethereum) {
          if (window.ethereum.providers && window.ethereum.providers.length) {
            for (var i = 0; i < window.ethereum.providers.length; i++) {
              var p = window.ethereum.providers[i];
              this.pushProvider(p);
            }
          } else {
            this.pushProvider(window.ethereum);
          }
        } else {
          // this.test_msg = 'no ether'
        }
      } else {
          // this.test_msg = 'has providers'
        }
    }
  },
  watch: {
    // Watch the $route object for changes
    $route: function $route(to, from) {
      log('Route changed from', from.path, 'to', to.path);
      // Umami tracks client-side route changes automatically
    }
  },
  created: function created() {
    var _this12 = this;

    log('---------CREATED--------');
    axios.get(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].getTsPath('config.json')).then(function (response) {
      console.log('---------- CONFIG ---------');
      console.log(response, response.data);
      var config = response.data;

      if (config.hasOwnProperty('ethPerPixel')) {
        _this12.ethPerPixel = config.ethPerPixel;
        console.log('Pixel price: ' + config.ethPerPixel);
      }

      if (config.hasOwnProperty('promo')) {
        if (config.promo) {
          _this12.showPromo = config.promo;
          if (config.promo.msg) {
            _this12.promoMsg = config.promo.msg;
          }
        } else {
          _this12.showPromo = false;
        }
      }
    });
  },
  mounted: function mounted() {
    var _this13 = this;

    log('---------MOUNTED--------');
    // this.toggleHomepageList = true;
    // initUploader(this); // triggered when child view loads
    // doCountdown();
    this.providers = [];
    setTimeout(function () {
      _this13.loadProviders();
    }, 5500); // TODO this sucks, but extending helps fighting wallets

    if (!localStorage.getItem(DID_PROMPT_NOTIFICATIONS)) {
      localStorage.setItem(DID_PROMPT_NOTIFICATIONS, true);
      this.initPushNotification();
    }

    this.watchedDemo = localStorage.getItem(LOCAL_STORAGE_KEY_DEMO_VID);
    if (!this.watchedDemo) {
      var loadPfpVid = function loadPfpVid() {
        return setTimeout(function () {
          _this13.pfpVidSrc = '/static/pfp-talking-head.webm';
        }, 1000);
      };
      if (document.readyState === 'complete') {
        loadPfpVid();
      } else {
        window.addEventListener('load', loadPfpVid, { once: true });
      }
    }

    this.isMobileOrTouch = __WEBPACK_IMPORTED_MODULE_11__utils__["a" /* default */].isMobileOrTouch();

    // Check for referral code
    if (window.location && window.location.search) {
      var urlParams = new URLSearchParams(window.location.search);
      var ref = urlParams.get('ref');
      if (ref) {
        // this.referralCode = ref;
        localStorage.setItem(LOCAL_STORAGE_KEY_REFERRAL, ref);
        this.saveEvent('referral', ref);
      }
    }

    window.addEventListener("eip6963:announceProvider", function (event) {
      log('eip6963:announceProvider', event.detail);
      trackEvent('hasWallet:' + event.detail.info.rdns);
      if (event.detail && ['app.phantom'].includes(event.detail.info.rdns)) {
        _this13.pushProvider(event.detail.provider);
      }
    });
    // setTimeout(()=> {
    //   window.dispatchEvent(new Event("eip6963:requestProvider"));
    // }, 1500);
  }
});

/***/ }),

/***/ "yA2K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.df8094c6b1c547b14598.js